//----------------------------------
// String constants for help modals
//----------------------------------

import { show_modal } from './modals';

export function display_help_modal(modal_type) {
  var helpModalTitle = "";
  var helpModalSummaryText = "-";
  var helpModalDefaultUsageHTML = "-";
  var helpModalAdditionalOptionsHTML = "-";
  var helpModalShortcutsHTML = "<p>No shortcuts for this operation.</p>";

  var link_pre = "";
  var link_post = "";
  if (!App.state.in_debug_mode) {
    link_pre = "/static/demo_ui/";
    link_post = "";
  }

  if (modal_type == "add_vertex") {
    helpModalTitle= "Add vertex";
    helpModalSummaryText = `Adds a new vertex on an existing edge.`;
    helpModalDefaultUsageHTML = `<p>
      Click on the icon, then click at the location on an edge where you want the vertex to be added.
      The vertex will be positioned at the point where the user clicks on the edge.
    </p>

    <div style="padding:56.25% 0 0 0;position:relative;">
        <iframe src="https://player.vimeo.com/video/562789144?loop=1&title=0&byline=0&portrait=0"
        style="position:absolute;top:0;left:0;width:100%;height:100%;"
        frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen>
        </iframe>
    </div>
    <script src="https://player.vimeo.com/api/player.js"></script>
    `;
    helpModalAdditionalOptionsHTML = `
    <p><b>Add vertex at middle with shift pressed:</b><br>
    If shift is pressed, the vertex will be positioned at the center of the edge instead.
    </p>
    <p><b>Tangency is added automatically:</b><br>
    The addition of the vertex will result in the edge being split in two. The two new edges will be made to join smoothly (i.e. they will be tangent)
    at the vertex. You can later remove this tangency requirement if you so wish (but with care, see 'Make edges join non-smoothly').
    </p>`;
    helpModalShortcutsHTML = `<p><ul>
    <li><b>V</b>: Add vertex.</li>
    <li><b>Shift-V</b>: Add vertex at middle of edge.</li>
    </ul></p>`;
  }


  else if (modal_type == "add_edge") {
    helpModalTitle= "Add edge on face";
    helpModalSummaryText = `Draw a new edge on a face, or add it between two vertices.`;
    helpModalDefaultUsageHTML = `<p>
    There are two ways to add an edge:</p>
    <p>
    (a) Click on the icon, then drag the mouse pressed over one or more faces. A new edge will appear over each face that was crossed.
    Make sure to keep the mouse pressed while crossing the face entirely, otherwise the procedure will be interrupted.
    </p>
    <p>
    (b) Select two vertices, then click on the icon. An edge will be added between them.
    </p>

    <div style="padding:56.25% 0 0 0;position:relative;">
        <iframe src="https://player.vimeo.com/video/562804729?loop=1&title=0&byline=0&portrait=0"
        style="position:absolute;top:0;left:0;width:100%;height:100%;"
        frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen>
        </iframe>
    </div>
    <script src="https://player.vimeo.com/api/player.js"></script>

    `;
    helpModalAdditionalOptionsHTML = `
    <p><b>Add a straight edge:</b><br>
    Again there are two ways to utilise this option:
    </p>
    <p>
    (a) When drawing an edge, if the shift button is pressed when clicking on the icon or when hitting the E shortcut, the motion of the mouse will be locked in a straight horizontal or perpendicular
    direction.
    </p>
    <p>
    (b) When adding an edge between two vertices, if the shift button is pressed the edge will be made straight.
    </p>
    <p>
    Note that edges that are made straight appear with a lighter color.
    </p>

    <p><b>Adding vertices while drawing edge:</b><br>
    While drawing an edge, if you hit the "V" key a vertex will be added on the edge at the cursor location.
    </p>

    </p>
    <p><b>Some care is needed when drawing edges:</b><br>
    The system will try to slightly smoothen any edges drawn on faces, to eliminate "noise" in mouse movements. You can then edit the edge by
    click-dragging it.
    </p>
    <p>
    In some cases the edge may appear with a shape that doesn't correspond to the mouse movement, depending on the drawing angle and the
    shape of the face. We're in the process of improving the fidelity of this functionality.
    </p>`;
    helpModalShortcutsHTML = `<p><ul>
    <li><b>E</b>: Add edge.</li>
    <li><b>Shift-E</b>: Add straight edge.</li>
    <li><b>V</b>: Add intermediate vertices while drawing edge.</li>
    </ul></p>`;
  }


  else if (modal_type == "fix_objects") {
    helpModalTitle= "Fix selected objects";
    helpModalSummaryText = `Makes the selected objects non-editable.`;
    helpModalDefaultUsageHTML = `<p>
    By fixing one or more objects you make sure that they will not be modified no matter what you do to them or other adjacent objects.</p>
    <p>
    Select one or more objects (faces, edges, vertices) and then click on the icon. They will turn gray to indicate that they are fixed.
    <p>
    If you select a set of all fixed objects and then click on the icon you will un-fix them.
     </p>
     <div style="padding:56.25% 0 0 0;position:relative;">
     <iframe src="https://player.vimeo.com/video/563995448?loop=1&title=0&byline=0&portrait=0"
     style="position:absolute;top:0;left:0;width:100%;height:100%;"
     frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen>
     </iframe>
    </div>
    <script src="https://player.vimeo.com/api/player.js"></script>
 `;
    helpModalAdditionalOptionsHTML = `
    <p><b>Fixing may currently limit some operations:</b><br>
    If you fix some object you may be limited in some operations. For example if you want to make some edges circular and one of
    them is fixed, you will not be allowed to proceed, even if there is a geometric solution that would give the expected result. We're working to
    add more "intelligence" to our operations to allow more results.
    </p>`;
    helpModalShortcutsHTML = `<p><ul>
    <li><b>X</b>: Fix objects.</li>
    <li><b>Shift-X</b>: Unfix objects.</li>
    </ul></p>`;
  }


  else if (modal_type == "delete_objects") {
    helpModalTitle= "Delete objects";
    helpModalSummaryText = `Deletes one or more selected objects.`;
    helpModalDefaultUsageHTML = `<p>
    Select one or more edges or vertices (but don't mix them, just one type of object at a time) and click on the icon to delete them.
    </p>
    <p>
    Note that deleting vertices that lie on more than two edges will also delete the edges.
    </p>

    <div style="padding:56.25% 0 0 0;position:relative;">
    <iframe src="https://player.vimeo.com/video/563995293?loop=1&title=0&byline=0&portrait=0"
    style="position:absolute;top:0;left:0;width:100%;height:100%;"
    frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen>
    </iframe>
   </div>
   <script src="https://player.vimeo.com/api/player.js"></script>

    `;
    helpModalAdditionalOptionsHTML = `
    <p><b>Deleting edges dissolves faces:</b><br>
    If you delete an edge, the two faces that were on either side of it will dissolve into one.
    </p>`;
    helpModalShortcutsHTML = `<p><ul>
    <li><b>Del</b> or <b>Backspace</b>: Delete objects</li>
    <li><b>Shift-Del</b> or <b>Shift-Backspace</b>: Delete selected edge(s) along with any floating vertices left</li>
    <li><b>2</b>: Delete non-fixed vertices with 2 edges only</li>
    <li><b>Shift-2</b>: As in "2", but keep the edge shape as is</li>
    </ul></p>`;
  }

  else if (modal_type == "make_invisible") {
    helpModalTitle= "Toggle Face Visibility";
    helpModalSummaryText = `Makes faces invisible or visible.`;
    helpModalDefaultUsageHTML = `<p>
    Select one or more faces and click on the icon to make them invisible. To restore an invisible face to visible, select the adjacent edge and click the button again.
    </p>
    <div style="padding:56.25% 0 0 0;position:relative;">
    <iframe src="https://player.vimeo.com/video/563995293#t=43s?loop=1&title=0&byline=0&portrait=0"
    style="position:absolute;top:0;left:0;width:100%;height:100%;"
    frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen>
    </iframe>
   </div>
   <script src="https://player.vimeo.com/api/player.js"></script>
   `;
    helpModalAdditionalOptionsHTML = `
    <p><b>Making faces invisible vs dissolving faces:</b><br>
    If you make a face invisible, it will disappear. However you may instead want to use the separate "dissolve faces" button in order
    to separate two parts of a body, to close a hole, or to merge various faces together.
    </p>
    <p><b>What about open surfaces?</b><br>
    An open surface is in fact a body with only some faces visible.
    </p>`;
  }


  else if (modal_type == "smoothen_vertices") {
    helpModalTitle= "Smooth vertices";
    helpModalSummaryText = `Makes smooth the selected vertices`;
    helpModalDefaultUsageHTML = `<p>
    Select one or more vertices, then click on the icon. </p>
    <p>
    Once you make a vertex smooth it will remain smooth as you edit your model. So the normals of all faces this vertex belongs to will
    be aligned at this vertex.<br>
    If already smooth vertices are selected, then clicking the icon will remove the smoothening requirement.
    </p>
    <div style="padding:56.25% 0 0 0;position:relative;">
    <iframe src="https://player.vimeo.com/video/564024113?loop=1&title=0&byline=0&portrait=0"
    style="position:absolute;top:0;left:0;width:100%;height:100%;"
    frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen>
    </iframe>
   </div>
   <script src="https://player.vimeo.com/api/player.js"></script>
   `;
    helpModalAdditionalOptionsHTML = `
    <p><b> Additive effect:</b><br>
    Repeatedly clicking on the icon will make the vertex progressively smoother.</p>`;
  }

  else if (modal_type == "unsmoothen_vertices") {
    helpModalTitle= "Remove vertex smoothness";
    helpModalSummaryText = `Removes smoothness requirement from the selected vertices`;
    helpModalDefaultUsageHTML = `<p>
    Select one or more vertices, then click on the icon. </p>
    <p>
    The shape will not instantly move, but smoothness will no longer be enforced.
    </p>
    <div style="padding:56.25% 0 0 0;position:relative;">
    <iframe src="https://player.vimeo.com/video/564024113?loop=1&title=0&byline=0&portrait=0"
    style="position:absolute;top:0;left:0;width:100%;height:100%;"
    frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen>
    </iframe>
   </div>
   <script src="https://player.vimeo.com/api/player.js"></script>
   `;
    helpModalAdditionalOptionsHTML = `<p><b>   </b><br></p>`;
  }


  else if (modal_type == "set_vertex_xyz") {
    helpModalTitle= "Set the XYZ coordinates of one or more vertices";
    helpModalSummaryText = `Allows directly setting the (x,y,z) coordinates of one or more vertices, all at once.`
    helpModalDefaultUsageHTML = `<p> Select one or more vertices, then click on the icon for an interface to appear.
     There are 3 options for each of the x, y and z coordinates:
     <ul class="help-modal-list">
    <li> Provide a value for it and apply it </li>
    <li> If more than one vertex are provided, make the value for all vertices equal to the current value of the first vertex that was selected </li>
    <li> Don't do anything to the coordinate value. </li>
    </ul>
    <br>
    This allows flexibility in moving vertices to the desired location.</p>
    <div style="padding:56.25% 0 0 0;position:relative;">
    <iframe src="https://player.vimeo.com/video/564006332?loop=1&title=0&byline=0&portrait=0"
    style="position:absolute;top:0;left:0;width:100%;height:100%;"
    frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen>
    </iframe>
   </div>
   <script src="https://player.vimeo.com/api/player.js"></script>
   `;
    helpModalAdditionalOptionsHTML = `
    <p><b> Not a constraint:</b><br>
    Note that this is not a constraint, currently, but a one-off operation. If the vertices are manipulated afterwards,
    their coordinates will not be maintained. A full constraint management system will be added to Phi soon, which should
    render entering coordinates unnecessary.</p>

    <p><b> Make many vertices co-planar:</b><br>
    As an example, assume 4 vertices were selected, and we want to make them all lie on the same plane that will be parallel
    to the X-Y plane and will pass through the first selected vertex. In this case, we would have:
    <ul>
    <li>the X coordinate of all vertices remain unchanged,</li>
    <li>the Y coordinate of all vertices remain unchanged,</li>
    <li>and the Z coordinate of all vertices to become equal to the Z coordinate of the first selected vertex.</li>
    </ul>
    The effect would be for all vertices to "drop on" the desired plane.</p>

    <p><b> Current coordinates displayed:</b><br>
    Note that the current coordinates of all selected vertices are displayed in the modal window that appears (with reduced precision), as a hint.</p>

    <p><b> Shift-clicking a vertex:</b><br>
    Note that you can quickly set the coordinates for a single vertex by simply shift-clicking it. Elements that are selected will move together with the shift-clicked vertex, once its coordinates change.</p>`;
  }


  else if (modal_type == "make_edge_linear") {
    helpModalTitle= "Make edges linear";
    helpModalSummaryText = `Turns one or more edges into straight lines.`;
    helpModalDefaultUsageHTML = `<p>
      Select one or more edges and click on the icon to make each one of them a straight line.
      The linearity will be preserved until explicitly broken by deforming the edge, or performing an operation that has to break it.
      </p>
      <p>
      Linear edges appear lighter in color.
      </p>
      <p>
      Click again to remove linearity requirement.
    </p>
    <div style="padding:56.25% 0 0 0;position:relative;">
    <iframe src="https://player.vimeo.com/video/564287303?loop=1&title=0&byline=0&portrait=0"
    style="position:absolute;top:0;left:0;width:100%;height:100%;"
    frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen>
    </iframe>
   </div>
   <script src="https://player.vimeo.com/api/player.js"></script>
   `;
    helpModalAdditionalOptionsHTML = `<p><b>This is a constraint:</b><br>
    Note that this linearity will be enforced from now on. For example if the vertex at the end of the edge is moved, the edge will remain linear.
    To "break" the linearity, you have to either click on the button again, or directly deform the edge.
    </p>`;
    helpModalShortcutsHTML = `<p><ul>
    <li><b>L</b>: Make edges linear.</li>
    </ul></p>`;

  }


  else if (modal_type == "make_edges_linear_as_one") {
    helpModalTitle= "Make edges collinear";
    helpModalSummaryText = `Makes a set of edges collinear, placing them along a straight line.`;
    helpModalDefaultUsageHTML = `<p>
      Select several connected edges and click on the icon to place them along a straight line. Each edge will also be set to linear.
      The first and last endpoint of the selected edges will dictate the line.
    </p>
    <div style="padding:56.25% 0 0 0;position:relative;">
    <iframe src="https://player.vimeo.com/video/564287303#t=30s?loop=1&title=0&byline=0&portrait=0"
    style="position:absolute;top:0;left:0;width:100%;height:100%;"
    frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen>
    </iframe>
   </div>
   <script src="https://player.vimeo.com/api/player.js"></script>
   `;
    helpModalAdditionalOptionsHTML = `<p><b>Not a constraint:</b><br>
    Note that only the linearity of each individual edge will be enforced from now on. If an intermediate vertex is moved,
    the edges will no longer be collinear.
    </p>`;
    helpModalShortcutsHTML = `<p><ul>
    <li><b>Shift-L</b>: Make edges collinear.</li>
    </ul></p>`;

  }



  else if (modal_type == "make_circular") {
    helpModalTitle= "Make circular";
    helpModalSummaryText = `Make a set of faces or edges circular.`;
    helpModalDefaultUsageHTML = `<p>
    Make a set of faces or a set of edges assume a circular shape, either a full circle or a circular arc. Phi will try to determine the best
    circular shape based on the initial shapes of the faces or edges.
    </p>
    <p> There are different uses:
    <ul class="help-modal-list">
    <li>Select one or more connected faces and click the icon to make them become a complete circle.
    The center and radius of the circle will be selected automatically based on the current geometry of the face(s).</li>
    <li>Select a closed loop of edges to form a complete circle, then click on the icon to make them become a complete circle.</li>
    <li>Select a chain of edges NOT forming a loop to create a circular arc, then click on the icon to turn them into a circular arc.</li>
    </ul>
    </p>
    <p> There are additional optional inputs:
    <ul class="help-modal-list">
    <li> A selected vertex that is not on the edges that will form the circle will be taken as an indication of where the center of the circle
    should lie.</li>
    <li> One or more selected vertices (but not more than 3) on the edges that will form the circle will be taken as indication that the
    circle should pass from these vertices. In the case of an open arc, the two endpoints are automatically used as indications, so only one more
    vertex can be selected.</li>
    </ul>
    </p>
    <div style="padding:56.25% 0 0 0;position:relative;">
    <iframe src="https://player.vimeo.com/video/564367631?loop=1&title=0&byline=0&portrait=0"
    style="position:absolute;top:0;left:0;width:100%;height:100%;"
    frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen>
    </iframe>
   </div>
   <script src="https://player.vimeo.com/api/player.js"></script>
   `;
    helpModalAdditionalOptionsHTML = `<p><b>Not a constraint:</b><br>
      Note that this is not a constraint, currently, but a one-off operation. So you can freely deform the edges of the circle afterwards.
      A full constraint management system will be added to Phi soon to provide permanent circularity.
    </p>`;
  }


  else if (modal_type == "make_circular_with_parameters") {
    helpModalTitle= "Make circular";
    helpModalSummaryText = `Make a set of faces or edges circular, specifying parameters.`;
    helpModalDefaultUsageHTML = `<p>
    The operation is similar to the regular "make circular" command, only the user can specify various parameters. Specifically:
    <ul class="help-modal-list">
    <li>Coordinates (x,y,z) for the center of the circle.</li>
    <li>The radius of the circle.</li>
    <li>The orientation (tilt) of the normal of the circle plane. This is given as a pair of angles of rotation with respect to the x and z axes.
    Preset angle value buttons are provided for convenience. The corresponding normal vector components are displayed for confirmation.</li>
    </ul>
    </p>
    <p>
    Apart from the specification of these parameters, the operation of the command is the same as for the "make circular".
    </p>
    <div style="padding:56.25% 0 0 0;position:relative;">
    <iframe src="https://player.vimeo.com/video/564367631#t=38s?loop=1&title=0&byline=0&portrait=0"
    style="position:absolute;top:0;left:0;width:100%;height:100%;"
    frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen>
    </iframe>
   </div>
   <script src="https://player.vimeo.com/api/player.js"></script>
   `;
    helpModalAdditionalOptionsHTML = `<p><b>Not a constraint:</b><br>
      Note that this is not a constraint, currently, but a one-off operation. So you can freely deform the edges of the circle afterwards.
      A full constraint management system will be added to Phi soon to provide permanent circularity.
    </p>`;
  }


  else if (modal_type == "fair") {
    helpModalTitle= "Fair one or more edges individually";
    helpModalSummaryText = `Fair each of the selected edges individually, making it smoother.`;
    helpModalDefaultUsageHTML = `<p>
    "Fairing" is the process of making an edge smoother, simpler, with less freedom to assume wavy shapes.
    Select one or more edges and click on the icon to fair them. Repeating fairs them more.
    </p>
   `;
    helpModalAdditionalOptionsHTML = `<p><b> Fairing many edges at once:</b><br>
    If more edges are selected, they can all be faired in one go. However each one of them will be faired individually,
    and no endpoints will move, even if two edges being faired are connected.
    </p>
    <p><b> Set fairing strength:</b><br>
       The strength of the fairing can be set from the Settings menu.
    </p>`;
  }


  else if (modal_type == "smoothen_edges") {
    helpModalTitle= "Smooth selected edges or area";
    helpModalSummaryText = `Smoothens selected edges, or area around selected vertices and/or faces.`;
    helpModalDefaultUsageHTML = `<p>
    <b>Selected edge(s):</b><br>
    Selected edges will smoothen. If a chain of edges is selected, the entire chain is smoothened as one single edge. The two endpoints of the chain will not move, but intermediate vertices will, unless Shift is pressed.<br>
    <b>Selected faces:</b><br>
    If one or more faces are selected, surrounding edges that form an angle <45&deg; will become tangent in pairs. Shift will keep vertices in place.<br>
    <b>Selected vertices:</b><br>
    If a vertex is selected, the edges coming out of this vertex that form an angle <45&deg; will become tangent in pairs. (This will not apply to any vertex which has more than 4 edges coming out, or is adjacent to a selected edge.)
    </p>

    <div style="padding:56.25% 0 0 0;position:relative;">
    <iframe src="https://player.vimeo.com/video/564024113?loop=1&title=0&byline=0&portrait=0"
    style="position:absolute;top:0;left:0;width:100%;height:100%;"
    frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen>
    </iframe>
   </div>
   <script src="https://player.vimeo.com/api/player.js"></script>
   `;

    helpModalAdditionalOptionsHTML = `<p><b> Useful for global smoothening:</b><br>
       This tool is often used to give a set of edges that define an entire body a smoother shape. For example spine edges running along the length
       of a design.
    </p>
    <p><b> Shift prevents unfixed vertices from moving:</b><br>
    In case you want the smoothening to take place without any vertex being moved, you can press Shift when you click this icon. Fixed vertices will have their location respected even if Shift is not pressed.
    </p>
    <p><b> Set Smoothen Strength:</b><br>
       The strength of the smothening can be set from the Settings menu.
    </p>
    <p><b> Additive effect:</b><br>
    Repeatedly clicking on the icon will make the edges progressively smoother.</p>`;
    helpModalShortcutsHTML = `<p><ul>
    <li><b>T</b>: Make edges tangent</li>
    <li><b>Shift-T</b>: Make edges tangent without moving vertices</li>
    </ul></p>`;
  }

  else if (modal_type == "unsmoothen_edges") {
    helpModalTitle= "Remove edge smoothness";
    helpModalSummaryText = `Removes smoothness requirement from the selected chain of edges`;
    helpModalDefaultUsageHTML = `<p>
    Select one or more edges, then click on the icon. </p>
    <p>
    The shape will change minimally, and smoothness will no longer be enforced.
    </p>
    <div style="padding:56.25% 0 0 0;position:relative;">
    <iframe src="https://player.vimeo.com/video/564024113#t=2m28s?loop=1&title=0&byline=0&portrait=0"
    style="position:absolute;top:0;left:0;width:100%;height:100%;"
    frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen>
    </iframe>
   </div>
   <script src="https://player.vimeo.com/api/player.js"></script>
   `;
    helpModalAdditionalOptionsHTML = `<p><b>   </b><br></p>`;
  }



  else if (modal_type == "make_edges_join_smoothly") {
    helpModalTitle= "Make two edges join smoothly";
    helpModalSummaryText = `Make two edges that share a vertex tangent.`;
    helpModalDefaultUsageHTML = `<p>
    Select the two edges, then click on the icon. It will then align the tangents of the edges at their common vertex.
    This tangency will be preserved throughout any operations and deformations applied to the edges.
    </p>
    <p>
    If the two edges already have a smooth joint (tangency) requirement, by selecting them both and clicking here we remove the tangency requirement. If we then deform the edges, they will no longer be tangent.
    </p>
    <p>
    If the two edges already have a smooth joint requirement, by selecting them both and clicking here we remove the tangency requirement.
    If we then deform the edges, they no longer need to be tangent.
    </p>
   `;
    helpModalAdditionalOptionsHTML = `<p>
    <b>This is a constraint:</b><br>
      This tangency constraint will be enforced once added. To remove it select the edge and click on the icon again.<br>
    <b>Add many tangencies together:</b><br>
      If you select a chain of many edges, tangencies will be added to all edge pairs.
      <br>
    <b>Careful with 0 or 180 degree angles:</b><br>
    If two edges already have a tangency constraint, and then this constraint is removed, it is currently possible for the shape of the faces
    involved to be imperfect. After any deformations are done, if the edges are still effectively tangent at their common vertex, it is strongly
     recommended for the tangency to be reinstated in order to avoid the face imperfections. Sometimes Phi will choose to do so automatically.<br>
    </p>`;
    helpModalShortcutsHTML = `<p><ul>
    <li><b>T</b>: Make edges tangent.</li>
    </ul></p>`;

  }


  else if (modal_type == "inflate_face") {
    helpModalTitle= "Inflate face";
    helpModalSummaryText = `Make the selected surfaces more 'inflated'.`;
    helpModalDefaultUsageHTML = `<p>
    Select one or more surfaces, then click the button. With each click, the surfaces will become more inflated or 'puffy'.
    This allows directly interacting with the shape of faces.
    </p>
    <div style="padding:56.25% 0 0 0;position:relative;">
    <iframe src="https://player.vimeo.com/video/556486725?loop=1&title=0&byline=0&portrait=0"
    style="position:absolute;top:0;left:0;width:100%;height:100%;"
    frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen>
    </iframe>
   </div>
   <script src="https://player.vimeo.com/api/player.js"></script>
   `;
    helpModalAdditionalOptionsHTML = `<p>
    <b>Click and drag:</b><br>
    If you click and drag directly on a face, you will inflate or deflate it, depending on the movement direction.<br>

    <b>Not always obvious:</b><br>
    Note that the effect of this operation when the shape of the face is particularly complex may not be obvious, and some experimentation may be
    required to get to the desired result. Alternatively, you may have to split the face or add edges for extra control.<br>

    <b>Currently a little limited:</b><br>
    For now the range of inflation/deflation is artificially restricted. Later more flexibility will be allowed.<br>

    <b>Face must not be flat:</b><br>
    If a face is initially flat (planar) you won't be allowed to inflate it.
    </p>`;
    helpModalShortcutsHTML = `<p><ul>
    <li><b>Click-drag</b>: Inflate or deflate face.</li>
    </ul></p>`;

  }

  else if (modal_type == "deflate_face") {
    helpModalTitle= "Deflate face";
    helpModalSummaryText = `Make the selected surfaces more 'deflated'.`;
    helpModalDefaultUsageHTML = `<p>
    Select one or more surfaces, then click the button. With each click, the surfaces will become more deflated or less 'puffy'.
    This allows directly interacting with the shape of faces.
    </p>
    <div style="padding:56.25% 0 0 0;position:relative;">
    <iframe src="https://player.vimeo.com/video/556486725?loop=1&title=0&byline=0&portrait=0"
    style="position:absolute;top:0;left:0;width:100%;height:100%;"
    frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen>
    </iframe>
   </div>
   <script src="https://player.vimeo.com/api/player.js"></script>
   `;
    helpModalAdditionalOptionsHTML = `<p>
    <b>Click and drag:</b><br>
    If you click and drag directly on a face, you will inflate or deflate it, depending on the movement direction.<br>

    <b>Not always obvious:</b><br>
    Note that the effect of this operation when the shape of the face is particularly complex may not be obvious, and some experimentation may be required to get to the desired result. Alternatively, you may have to split the face or add edges for extra control.<br>

    <b>Currently a little limited:</b><br>
    For now the range of inflation/deflation is artificially restricted. Later more flexibility will be allowed.<br>

    <b>Face must not be flat:</b><br>
    If a face is initially flat (planar) you won't be allowed to deflate it.
    </p>`;
    helpModalShortcutsHTML = `<p><ul>
    <li><b>Click-drag</b>: Inflate or deflate face.</li>
    </ul></p>`;
  }


  else if (modal_type == "flatten") {
    helpModalTitle= "Flatten faces or edges";
    helpModalSummaryText = `Make a set of selected faces and/or edges flat (planar)`;
    helpModalDefaultUsageHTML = `<p>
    Select one or more faces and/or edges, then click on the button to make them all flat (planar).

    There are different ways to use this functionality:
    <ul class="help-modal-list">
      <li> Just select one or more faces or edges. They will all be flattened on a plane calculated by Phi based on the geometry of the selected objects. If at least one flat face is selected, all other objects will be made planar upon its plane (or upon the plane of the first one selected).</li>
      <li> Additionally select three vertices. In this case the three vertices will be used to indicate the plane upon which all selected objects will lie after they are made flat.</li>
    </ul>
    </p>
    <div style="padding:56.25% 0 0 0;position:relative;">
    <iframe src="https://player.vimeo.com/video/564184232?loop=1&title=0&byline=0&portrait=0"
    style="position:absolute;top:0;left:0;width:100%;height:100%;"
    frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen>
    </iframe>
   </div>
   <script src="https://player.vimeo.com/api/player.js"></script>
   `;
    helpModalAdditionalOptionsHTML = `<p><b> Snap to orthogonal axes:</b><br>
    If there are no planar faces or vertices selected to dictate the plane upon which to make everything flat,
    and no vertices to indicate the plane within which to flatten, then Phi will calculate a plane based on the geometry of the selected objects. If this plane
    ends up being close to one of the three orthogonal planes (xy, yz, xz), then Phi will opt to use the orthogonal plane instead, assuming that was the intention
    of the user.
    </p>`;
  }


  else if (modal_type == "rigid_move") {
    helpModalTitle= "Rigid move manipulator";
    helpModalSummaryText = `Rigidly move (rotate, translate) or scale a set of objects, specifically a set of faces or edges.`;
    helpModalDefaultUsageHTML = `<p>Select a set of faces and/or edges, then click the icon to display a manipulator with the following affordances:
    <ul class="help-modal-list">
        <li>Drag any straight axis to move the selected objects along the axis.</li>
        <li>Drag any green ring to rotate the object around each of the corresponding axis.</li>
        <li>Drag any of the three planes to move selected objects on this plane.</li>
        <li>Click on a green ring to specify an exact rotation angle.</li>
        <li>Drag any of the three small balls at the tips of the three axes to scale the model along the corresponding axis (non-proportional scaling).
        Keep the shift button pressed for a proportional scale of the entire object.</li>
        <li>Freely drag the white cube for a free translation.</li>
    </ul>
    When done click anywhere on the scene, or hit escape, or click the 'Rigid move' button again to hide the manipulator.</p>
    <br>
    <div style="padding:56.25% 0 0 0;position:relative;">
    <iframe src="https://player.vimeo.com/video/564005989?loop=1&title=0&byline=0&portrait=0"
    style="position:absolute;top:0;left:0;width:100%;height:100%;"
    frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen>
    </iframe>
   </div>
   <script src="https://player.vimeo.com/api/player.js"></script>
   `;
    helpModalAdditionalOptionsHTML = `<p>
    <b>Local and global placement:</b><br>
    The manipulator can be placed along a local coordinate system that is calculated from the selected objects, or the global coordinate system
    of the model, i.e. along the main coordinate axes. To switch between the two placements you can hit the "G" and "L" keys, for global and local
    respectively.<br>
    <b>Positioning the manipulator:</b><br>
    <ul class="help-modal-list">
    <li>The manipulator will be positioned in an intuitive and expected way, e.g. at the middle of and perpendicular to
    any almost-flat face.</li>
    <li>If a single vertex is also selected, the manipulator will be centered at that vertex.</li>
    <li>If two vertices are selected, then it will be positioned at the first vertex and rotated so that its axis points towards the
    second vertex.</li>
    </ul>
    <p><b>Repositioning the manipulator:</b><br>
    Any movements done to the manipulator while the SHIFT button is pressed will result in the manipulator moving without the objects
    following. This way you can better position the manipulator before its action is applied to the objects.</p>
    <p><b>Rotating single vertex:</b><br>
    If a single vertex is selected, and it is a rounded vertex, rotating it will result in rotating the common normal of the faces that meet at the vertex.</p>
    <p><b>Snapping to grid:</b><br>
    If the grid is displayed, the manipulator will snap onto it as it moves.</p>`;
    helpModalShortcutsHTML = `<p><ul>
    <li><b>M</b>: Show or hide manipulator</li>
    <li><b>L,G</b>: Switch between local and global placement.</li>
    <li><b>L</b>: In edge tangent manipulation mode, align manipulator with tangent.</li>
    <li><b>Shift</b>: While dragging, the manipulator is repositioned.</li>
    <li><b>Shift</b>: While scaling, scale proportionately.</li>
    </ul></p>`;
  }


  else if (modal_type == "scale_objects") {
    helpModalTitle= "Scale Objects";
    helpModalSummaryText = `Scale a set of objects.`;
    helpModalDefaultUsageHTML = `<p>Select a set of faces and/or edges, then click the icon to display a modal window for scaling them.
    You can optionally also select one or two vertices. The window displays a menu for resizing the selected objects along the three
    coordinate axes or proportionately, by providing a scaling percentage and indicating if you want the scaling to be proportional or along
    one of the coordinate axes.</p>
    <div style="padding:56.25% 0 0 0;position:relative;">
    <iframe src="https://player.vimeo.com/video/564006122?loop=1&title=0&byline=0&portrait=0"
    style="position:absolute;top:0;left:0;width:100%;height:100%;"
    frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen>
    </iframe>
   </div>
   <script src="https://player.vimeo.com/api/player.js"></script>
   `;
    helpModalAdditionalOptionsHTML = `
    <p><b>Locking vertex:</b><br>
    If at least one vertex is selected, you can select to "lock" the first selected vertex and use it as the center for the scaling.</p>
    <p><b>Scaling based on dimensions:</b><br>
    If two vertices are selected, the distance between them will be displayed, both directly and along the three coordinate axes. You then have
    the option to scale by giving a new value for the distance, rather than a percentage.</p>
    `;
    helpModalShortcutsHTML = `<p><ul>
    <li><b>D</b>: Quick scale body</li>
    <li><b>Shift-D</b>: Scale</li>
    </ul></p>`;
  }


  else if (modal_type == "offset_face") {
    helpModalTitle= "Offset Face";
    helpModalSummaryText = `Offset a face.`;
    helpModalDefaultUsageHTML = `<p> The face offset operation can be applied to any face
    (either flat or reasonably-shaped). The operation is carried out as follows:
    <ul class="help-modal-list">
      <li> Select a face, then click on the icon. The face will turn blue.</li>
      <li> Click on a vertex at the boundary of the face, and then click at a point in the face where you would like that vertex to move to.</li>
      <li> A new contour will be formed there, offsetting the original contour of the face.
      <li> Move your mouse to vary the contour position interactively.
      <li> When you are finished, click at the location where you would like the contour to remain.</li>
    </ul>
    </p>
    <div style="padding:56.25% 0 0 0;position:relative;">
    <iframe src="https://player.vimeo.com/video/562824627?loop=1&title=0&byline=0&portrait=0"
    style="position:absolute;top:0;left:0;width:100%;height:100%;"
    frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen>
    </iframe>
   </div>
   <script src="https://player.vimeo.com/api/player.js"></script>
   `;
    helpModalAdditionalOptionsHTML = `<p><b>Careful with offset limits:</b><br>
    We currently don't check the limits of the contour, so it can be dragged outside the face. This is not a problem for Phi,
    but probably not what you desire, so it's up to you to select the offset contour you want.</p>`;
    helpModalShortcutsHTML = `<p><ul>
    <li><b>O</b>: Offset face.</li>
    </ul></p>`;

  }


  else if (modal_type == "popout") {
    helpModalTitle= "Pop out";
    helpModalSummaryText = `Extrude faces or boundary edges.`;
    helpModalDefaultUsageHTML = `<p>
    <b>Faces:</b> Select one or more faces of a closed body and click the button to modify by adding material.<p>
    <b>Edges:</b> If you are working with open bodies, select one or more of their boundary edges and click the button, to extend by creating new faces.
    </p>
    <div style="padding:56.25% 0 0 0;position:relative;">
    <iframe src="https://player.vimeo.com/video/563647678?loop=1&title=0&byline=0&portrait=0"
    style="position:absolute;top:0;left:0;width:100%;height:100%;"
    frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen>
    </iframe>
   </div>
   <script src="https://player.vimeo.com/api/player.js"></script>
   `;
    helpModalAdditionalOptionsHTML = `<p><b>Pop-out, then rigid-move or scale:</b><br>
    A very typical way of working is to pop-out an element (face or boundary edge), and then pull it with a rigid move, or rescale it. This allows quickly building and
    extending the shape of our models. That's why we immediately display the rigid move manipulator after the pop-out.
    If you don't wish to perform a rigid move simply click anywhere on the screen, or hit Escape, to get rid of the manipulator.
    </p>`;
    helpModalShortcutsHTML = `<p><ul>
    <li><b>P</b>: Pop-out.</li>
    </ul></p>`;

  }

  else if (modal_type == "popout_cut") {
    helpModalTitle= "Thicken";
    helpModalSummaryText = `Pop out (extrude) the selected faces to thicken them, and get rid of everything else.`;
    helpModalDefaultUsageHTML = `<p>
    Select one or more faces and click here to "thicken" them. <br>
    An operation very similar to pop-out, except every other pre-existing face is deleted, and the result is a "thickened" version
    of the selected faces.
    </p>
    <div style="padding:56.25% 0 0 0;position:relative;">
    <iframe src="https://player.vimeo.com/video/563647678#t=59s?loop=1&title=0&byline=0&portrait=0"
    style="position:absolute;top:0;left:0;width:100%;height:100%;"
    frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen>
    </iframe>
   </div>
   <script src="https://player.vimeo.com/api/player.js"></script>
   `;
    helpModalAdditionalOptionsHTML = `<p><b>From 0-thickness surface to closed body:</b><br>
    A typical use of this operation is if you start with a 0-thickness surface, and then you want to "thicken" it to turn it into a closed
    body.
    </p>`;
  }

  else if (modal_type == "popin") {
    helpModalTitle= "Make face pop in";
    helpModalSummaryText = `Make face pop inside the body`;
    helpModalDefaultUsageHTML = `<p>
    Similar to pop-out, but now the face is pushed inside the volume of the body, and new edges and faces are added to maintain its closed surface.
    </p>
    <div style="padding:56.25% 0 0 0;position:relative;">
    <iframe src="https://player.vimeo.com/video/563647678#t=50s?loop=1&title=0&byline=0&portrait=0"
    style="position:absolute;top:0;left:0;width:100%;height:100%;"
    frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen>
    </iframe>
   </div>
   <script src="https://player.vimeo.com/api/player.js"></script>
   `;
    helpModalAdditionalOptionsHTML = `<p><b>Pop-in, then rigid-move or scale:</b><br>
    Similar to pop-out, you get the rigid move manipulator manipulator displayed after the pop-in.
    </p>`;

  }


  else if (modal_type == "carve") {
    helpModalTitle= "Carve";
    helpModalSummaryText = `Carve through the model, adding edges on all faces crossed.`;
    helpModalDefaultUsageHTML = `<p>
    Click on the icon, then drag the mouse pressed over one or more faces. Make sure to keep the mouse pressed while crossing the face entirely,
    otherwise the procedure will be interrupted.
    </p>
    <p>
    Carve is similar to drawing edges. The difference is that the mouse movement is interpreted as "slicing through the body", adding edges
    on all faces crossed, both visible and hidden.
    </p>
    <div style="padding:56.25% 0 0 0;position:relative;">
    <iframe src="https://player.vimeo.com/video/562775652?loop=1&title=0&byline=0&portrait=0"
    style="position:absolute;top:0;left:0;width:100%;height:100%;"
    frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen>
    </iframe>
   </div>
   <script src="https://player.vimeo.com/api/player.js"></script>
   `;
    helpModalAdditionalOptionsHTML = `<p><b>Carve, then remove:</b><br>
    A typical use of this operation is to carve through the body, then select one of the sliced parts and remove it. Note that if you hit "delete"
    you will be left with an empty space. Using "dissolve faces" will remove the one part of the body, and replace it with a new surface to fill
    its space, so this is the recommended way.
    </p>

    <p><b>Carving along a straight line:</b><br>
    If the shift button is pressed when clicking on the icon or when hitting the C shortcut, the motion of the mouse will be locked in a straight horizontal or perpendicular
    direction.
    </p>

    <p><b>Adding vertices while drawing edge:</b><br>
    While drawing an edge, if you hit the "V" key a vertex will be added on the edge at the cursor location.
    </p>`;

    helpModalShortcutsHTML = `<p><ul>
    <li><b>C</b>: Carve.</li>
    <li><b>Shift-C</b>: Carve along straight line.</li>
    <li><b>V</b>: Add intermediate vertices while carving.</li>
    </ul></p>`;

  }




  else if (modal_type == "hole") {
    helpModalTitle= "Hole across body";
    helpModalSummaryText = `Create a hole across the body`;
    helpModalDefaultUsageHTML = `<p>
    If two faces are selected, a hole can be 'drilled' across the body from one to the other. New edges and faces are added to maintain the closed surface.
    </p>
    <div style="padding:56.25% 0 0 0;position:relative;">
    <iframe src="https://player.vimeo.com/video/563659141?loop=1&title=0&byline=0&portrait=0"
    style="position:absolute;top:0;left:0;width:100%;height:100%;"
    frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen>
    </iframe>
   </div>
   <script src="https://player.vimeo.com/api/player.js"></script>
   `;
    helpModalAdditionalOptionsHTML = `<p>
    <b>A lot of freedom:</b><br>
    The shapes of the two faces need not be similar, nor the number of edges surrounding them or their general orientation. There is a lot of freedom to the types of holes that can be created. It is good however to be careful to not generate excessively weird or self-intersecting shapes. For now the responsibility is in the hands of the user.<br>
    <b>Faces need to be separated:</b><br>
    A hole will only be allowed between faces that are separated by more than one face and edge. This current restriction may be a little excessive but it is temporary.
    </p>`;
  }

  else if (modal_type == "bridge") {
    helpModalTitle= "Make Bridge";
    helpModalSummaryText = `Create a bridge connecting faces or edges at the borders of open surfaces`;
    helpModalDefaultUsageHTML = `<p>
    <b>Bridging faces:</b><br>
    The opposite operation of a hole is a bridge. Again two or more faces are selected (with the same freedom and restrictions) and a bridge will be added to connect them. New edges and faces will be generated to maintain the closed surface of the entire body. Phi will attempt a freeform bridge if Shift is pressed when this button is clicked.
    </p>
    <p>
    <b>Bridging edges at the borders of open surfaces:</b><br>
    This will create a new face, and the selected edges will constitute boundaries of its. For optimum results, this operation is preferably performed with a minimum number of selected edges.
    </p>

    <div style="padding:56.25% 0 0 0;position:relative;">
    <iframe src="https://player.vimeo.com/video/563667846?loop=1&title=0&byline=0&portrait=0"
    style="position:absolute;top:0;left:0;width:100%;height:100%;"
    frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen>
    </iframe>
   </div>
   <script src="https://player.vimeo.com/api/player.js"></script>
   `;

    helpModalAdditionalOptionsHTML = `<p><b>Freeform bridge between faces (Shift):</b><br>
    A bridge created is made of linear edges by default. However, for bridges between faces, Phi will attempt a freeform bridge if Shift is pressed when this button is clicked.</p>

    <p><b>Make reasonable bridges:</b><br>
    It is easy to come up with weird and not very useful bridges. It is better to only use faces oriented in a way that a bridge can nicely connect them.</p>

    <p><b>Inflate to fix faces:</b><br>
    After a bridge is generated, it is likely that the faces won't have the desired shape. Usually by inflating the surfaces we can get
    much closer to the desired shape of the bridge.<br></p>

    <p><b>Patching long gaps</b><br>
    To bridge two chains of edges lengthwise, it's best to bridge minimum edges (two or three) repeatedly, rather than multiple together.<br></p>

    <p><b>Edges are selected, why is the button inactive?</b><br>
    Edges that can be bridged are those that lie at the borders of open surfaces. If the selected edges are not such, the button will be inactive. However, you can make an edge eligible for this operation by selecting one of its adjacent faces and making it "invisible" (with the button: "Toggle face visibility").</p>`;

  }

  else if (modal_type == "merge_on_edge") {
    helpModalTitle= "Stitch two edges";
    helpModalSummaryText = `Join two bodies or open faces on edge.`;
    helpModalDefaultUsageHTML = `<p>
    Select the pair of edges to stitch, and click the button. If one of the edges needs to move for the stitch to take place, the second-selected one will move.
    </p>
    <div style="padding:56.25% 0 0 0;position:relative;">
    <iframe src="https://player.vimeo.com/video/563695414?loop=1&title=0&byline=0&portrait=0"
    style="position:absolute;top:0;left:0;width:100%;height:100%;"
    frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen>
    </iframe>
   </div>
   <script src="https://player.vimeo.com/api/player.js"></script>
   `;
    helpModalAdditionalOptionsHTML = `<p>
    <b>Selecting coincident edges</b><br>
    In case the edges are coincident and you cannot select them, please select the adjacent faces instead.<br>
    </p>`;

  }

  else if (modal_type == "snap_to_body") {
    helpModalTitle= "Mate bodies";
    helpModalSummaryText = `Mate two bodies based on selected elements.`;
    helpModalDefaultUsageHTML = `<p>
    Select elements from two bodies, and move the first one so that it attaches to the second one based on the selected elements. The first
    body will translate and rotate as necessary. If the Shift button is pressed, only the selected elements will move so the body will deform.
    You can select either a pair of faces, or one or two pairs of edges, or one to three pairs of vertices. You must first select the elements
    of the first face and then the elements of the second one, in corresponding order.
    </p>
    <div style="padding:56.25% 0 0 0;position:relative;">
    <iframe src="https://player.vimeo.com/video/564006398?loop=1&title=0&byline=0&portrait=0"
    style="position:absolute;top:0;left:0;width:100%;height:100%;"
    frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen>
    </iframe>
   </div>
   <script src="https://player.vimeo.com/api/player.js"></script>
   `;
    helpModalAdditionalOptionsHTML = `<p>
    <b>Only vertices attach:</b><br>
    The first body will move so that the vertices will attach onto the second body in a linear fashion. In other words if the edges are not
    straight, the two bodies will not match perfectly. This is a quick way of positioning a body next to another, it is not meant as an exact
    match or merge of the two bodies.
    </p>`;
    helpModalShortcutsHTML = `<p><ul>
    <li><b>J</b>: Snap bodies rigidly.</li>
    <li><b>Shift-J</b>: Snap bodies deforming the first one.</li>
    </ul></p>`;
  }


  else if (modal_type == "make_symmetric") {
    helpModalTitle= "Add edges or faces to symmetry set";
    helpModalSummaryText = `Adds selected edges or faces to the symmetry set, making them symmetric to one another with respect to a symmetry plane`;
    helpModalDefaultUsageHTML = `<p>
    For applying symmetry to a set of edges, you must first define a symmetry plane. Once a symmetry plane is defined, you need to select two sets of
    edges and/or faces that lie on opposite sides of the plane.<br>
    Once the two sets are selected, click on the icon to make them symmetric. The edges of the two sets will take different colors for
    verification/easy visualisation.
    If you edit an object of the symmetry set, the opposite side will follow the movement to remain symmetric.
    </p>
    <div style="padding:56.25% 0 0 0;position:relative;">
    <iframe src="https://player.vimeo.com/video/563145032#t=29s?loop=1&title=0&byline=0&portrait=0"
    style="position:absolute;top:0;left:0;width:100%;height:100%;"
    frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen>
    </iframe>
   </div>
   <script src="https://player.vimeo.com/api/player.js"></script>
   `;
    helpModalAdditionalOptionsHTML = `
    <p>
    <b>Careful with edges crossing the symmetry plane:</b><br>
    In an attempt to add all possible selected edges in the symmetry plane, we try to avoid adding edges that you did not intend to. We will generally
    reject edges that cross the symmetry plane. But if a selected
    edge crosses the symmetry plane slightly we may identify a corresponding selected edge on the opposite side and handle these together. But it is
    possible that we will be left with two asymetric sets of edges, i.e. with two sets with different numbers of edges on either side, in which case
    we will not be able to add the symmetry.

    It is recommended that you carefully select the edges and/or planes that you want symmetry to be applied on, to avoid such situations. You can
    also add them gradually, a few at a time.
    </p><p>
    <b>Add more to the symmetry sets:</b><br>
    After you have set your symmetry, you can select two new sets of edges/faces and repeat the process. These two sets will be appended to the
    existing symmetry set, so you can expand it.
    </p><p>
    <b>Symmetric edges should not cross the symmetry plane:</b><br>
    If there is an edge crossing the symmetry plane and you want to apply symmetry to it, then you have to add a vertex on it, close to where the
    symmetry plane intersects it, to split it into two edges. Then you can apply symmetry between these two edges. Notice that the vertex doesn't
    need to lie exactly on the symmetry plane, Phi will take care of this when applying the symmetry.<br>
    </p>`;
    helpModalShortcutsHTML = `<p><ul>
    <li><b>Y</b>: Make symmetric.</li>
    </ul></p>`;

  }

  else if (modal_type == "remove_from_symmetry_sets") {
    helpModalTitle= "Removes selected edges or faces from the symmetry set";
    helpModalSummaryText = `Removes the selected edges or faces from the two symmetry sets.`;
    helpModalDefaultUsageHTML = `<p>
    Given a symmetry is already active, select any edges or faces and hit this button to remove them from the symmetry sets.
    </p>
    <div style="padding:56.25% 0 0 0;position:relative;">
    <iframe src="https://player.vimeo.com/video/563145032#t=1m17s?loop=1&title=0&byline=0&portrait=0"
    style="position:absolute;top:0;left:0;width:100%;height:100%;"
    frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen>
    </iframe>
   </div>
   <script src="https://player.vimeo.com/api/player.js"></script>
   `;
    helpModalAdditionalOptionsHTML = `
    <p>
    <b>Opposite side edges also removed:</b><br>
    If you select an edge only to remove, the corresponding edge on the opposite side will also be removed.<br>
    </p>`;
  }

  else if (modal_type == "set_symmetry_plane") {
    helpModalTitle= "Set or clear symmetry";
    helpModalSummaryText = `Define a plane to be used to make two sets of edges/faces symmetric, or clear an existing symmetry.`;
    helpModalDefaultUsageHTML = `<p>
    To set a symmetry, first you click on the icon to enter the "setting symmetry plane" mode. You can then either select one of the
    three orthogonal planes by clicking on them, or click on a planar face, or on 3 vertices to define the symmetry plane you want.
    </p>
    <p>
    If a symmetry is already set when you click on the icon, the symmetry plane will be removed and the symmetry constraint will no longer be applied.
    </p>
    <div style="padding:56.25% 0 0 0;position:relative;">
    <iframe src="https://player.vimeo.com/video/563145032?loop=1&title=0&byline=0&portrait=0"
    style="position:absolute;top:0;left:0;width:100%;height:100%;"
    frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen>
    </iframe>
   </div>
   <script src="https://player.vimeo.com/api/player.js"></script>
   `;
    helpModalAdditionalOptionsHTML = `
    <p>
    <b>Hiding the symmetry plane:</b><br>
    If the symmetry plane gets in the way of your design work, you can hide it by hiding the orthogonal axes. The symmetry will still be applied,
    but the plane will not be visible.
    </p>
    <b>Both sets and the plane are cleared:</b><br>
    Clearing the symmetry means both sets and the symmetry plane are lost. To define the symmetry again you need to repeat the entire process.
    </p>`;
  }


  else if (modal_type == "clear_symmetry") {
    helpModalTitle= "Clear symmetry";
    helpModalSummaryText = `Clears the selected symmetry plane and removes the symmetry constraint`;
    helpModalDefaultUsageHTML = `<p>
    If you click on the icon the symmetry plane will be removed and the symmetry constraint will no longer be applied.
    </p>
    <div style="padding:56.25% 0 0 0;position:relative;">
    <iframe src="https://player.vimeo.com/video/563145032#t=1m35s?loop=1&title=0&byline=0&portrait=0"
    style="position:absolute;top:0;left:0;width:100%;height:100%;"
    frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen>
    </iframe>
   </div>
   <script src="https://player.vimeo.com/api/player.js"></script>
   `;
    helpModalAdditionalOptionsHTML = `
    <p>
    <b>Both sets and the plane are cleared:</b><br>
    Clearing the symmetry means both sets and the symmetry plane are lost. To define the symmetry again you need to repeat the entire process.
    </p>`;
  }


  else if (modal_type == "merge_faces") {
    helpModalTitle= "Dissolve patches";
    helpModalSummaryText = `Dissolve adjacent patches (faces).`;
    helpModalDefaultUsageHTML = `<p>
      Select a set of faces, then click on the icon to remove them and substitute them with one or more faces, depending on the set of
      edges that are around them. Any edges between the selected faces will be removed.
    </p>
    <div style="padding:56.25% 0 0 0;position:relative;">
    <iframe src="https://player.vimeo.com/video/563995366?loop=1&title=0&byline=0&portrait=0"
    style="position:absolute;top:0;left:0;width:100%;height:100%;"
    frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen>
    </iframe>
   </div>
   <script src="https://player.vimeo.com/api/player.js"></script>
   `;
    helpModalAdditionalOptionsHTML = `
    <p>
    <b>Faces must be adjacent:</b><br>
    All of the selected faces must be adjacent, i.e. form one connected surface area.
    </p>
    <b>Split bodies:</b><br>
    Dissolving a loop of faces may result in splitting a body into two.
    </p>
    <b>Fill holes:</b><br>
    Dissolving a ring of faces around the inside of a hole will result in two new faces being added to effectively fill the hole.
    </p>`;
  }

  else if (modal_type == "splitpatch") {
    helpModalTitle= "Split patches";
    helpModalSummaryText = `Split a patch into several pieces.`;
    helpModalDefaultUsageHTML = `<p>
      Select one or more patches (faces), then click on the icon. Each patch will be split into as many pieces as the number of edges around them.
      Faces with regular shapes (e.g. squares) will be split into smaller squares. Faces with more arbitrary shapes will be split into more
      arbitrarily-shaped faces.
    </p><p>
    By default, the selected face will be split by connecting the middles of its surrounding edges. If Shift is held down when the button is clicked, the selected face(s) will be split by connecting its surrounding vertices.
    </p>
    <div style="padding:56.25% 0 0 0;position:relative;">
    <iframe src="https://player.vimeo.com/video/562815623?loop=1&title=0&byline=0&portrait=0"
    style="position:absolute;top:0;left:0;width:100%;height:100%;"
    frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen>
    </iframe>
   </div>
   <script src="https://player.vimeo.com/api/player.js"></script>
   `;
    helpModalAdditionalOptionsHTML = `
    <p>
    <b>Limit to number of patches:</b><br>
    There currently is a limit to the number of faces that can be split simultaneously. So if you want to split a large number of faces, you have
    to do it in groups.
    </p>`;
    helpModalShortcutsHTML = `<p><ul>
    <li><b>S</b>: Split patch at the middles of its edges</li>
    <li><b>Shift-S</b>: Split patch at its vertices</li>
    </ul></p>`;
  }


  else if (modal_type == "fill_faces") {
    helpModalTitle= "Fill patches";
    helpModalSummaryText = `Fills an empty space adjacent to other faces.`;
    helpModalDefaultUsageHTML = `<p>
      To fill a space left when a face was deleted, click on one of the edges surrounding the empty space, then click on this icon. The space
      will be filled by a face.
    </p>
    <div style="padding:56.25% 0 0 0;position:relative;">
    <iframe src="https://player.vimeo.com/video/563995293#t=1m06s?loop=1&title=0&byline=0&portrait=0"
    style="position:absolute;top:0;left:0;width:100%;height:100%;"
    frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen>
    </iframe>
   </div>
   <script src="https://player.vimeo.com/api/player.js"></script>
   `;
    helpModalAdditionalOptionsHTML = `
    <p>
    <b>More faces to fill one space:</b><br>
    Depending on the original model shape, there may be need to repeat the process, so that more faces will be used to fill the empty space.
    After selecting one edge and partially filling the space, select another edge on the border and repeat.
    </p>`;
  }



  else if (modal_type == "load_sketches") {
    helpModalTitle= "Import reference sketch";
    helpModalSummaryText = `Import a .jpg, .png or .gif file to use as reference.`;
    helpModalDefaultUsageHTML = `<p>
    Click on the icon to display an interface for selecting a reference sketches to load. Optionally, you can also define an initial orientation and dimensions. The position and size can be changed later, using the "Edit" button.
    </p>
    <div style="padding:56.25% 0 0 0;position:relative;">
    <iframe src="https://player.vimeo.com/video/701264992?loop=1&title=0&byline=0&portrait=0"
    style="position:absolute;top:0;left:0;width:100%;height:100%;"
    frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen>
    </iframe>
   </div>
   <script src="https://player.vimeo.com/api/player.js"></script>
    `;
    helpModalAdditionalOptionsHTML = `
    <p>
    <b>Load more reference sketches:</b><br>
    You can click the button again and load more reference sketches.
    </p>`;
  }


  else if (modal_type == "edit_sketches") {
    helpModalTitle= "Edit reference sketches";
    helpModalSummaryText = `While in this mode, the reference sketches become editable, and you can use the relevant tools to change their size and position.`;
    helpModalDefaultUsageHTML = `<p>
    Click on the icon to enter "Edit" mode. Then modify on any sketch (or sketches) by using the standard tools as usual.<br>
    When done, click on the icon again to exit the "Edit" mode.</p>
    <div style="padding:56.25% 0 0 0;position:relative;">
    <iframe src="https://player.vimeo.com/video/701264992#t=1m02s?loop=1&title=0&byline=0&portrait=0"
    style="position:absolute;top:0;left:0;width:100%;height:100%;"
    frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen>
    </iframe>
   </div>
   <script src="https://player.vimeo.com/api/player.js"></script>
    `;
    helpModalAdditionalOptionsHTML = `<p>The tools that can be used while in this mode are: Delete, Move manipulator (to move, rotate or scale), Scale and Quick-Scale ("D"), Place, Shift-clicking on vertex, dragging a vertex.</p>`;
  }

  else if (modal_type == "grid") {
    helpModalTitle= "Show Grid";
    helpModalSummaryText = `Show or hide a grid.`;
    helpModalDefaultUsageHTML = `<p>
    When the grid is displayed, vertices will snap on it. The grid spacing can be set from the "Settings" menu</p>
    `;
    helpModalAdditionalOptionsHTML = `
    <p>
    When the grid is displayed the rotation of the rigid movement manipulator takes place in steps.
    </p>`;
  }

  else if (modal_type == "working_plane") {
    helpModalTitle= "Set working plane";
    helpModalSummaryText = `Set or unset a "working plane". All vertex movements will be confined to be on, or parallel to this plane.`;
    helpModalDefaultUsageHTML = `<p>
    To set the working plane select three vertices and then click on the icon. A plane will appear. Any vertex movement, regardless of the
    viewpoint will be confined within this plane if the vertex is already on it, or within a plane parallel to this one. <br>
    Click again on the icon to remove the working plane.
    `;
    helpModalAdditionalOptionsHTML = `
    <p>
    The working plane is useful when performing operations at an oblique angle.
    </p>`;
  }

  else if (modal_type == "rotate_edge_tangent") {
    helpModalTitle= "Manipulate edge tangent";
    helpModalSummaryText = `Manipulate the tangent of an edge on either side.<br> Select an edge, then click here for two manipulators to appear.`;
    helpModalDefaultUsageHTML = `<p>
      Select an edge and click on the icon. Two manipulators will appear that will allow you to rotate the tangents at either endpoint of the edge.
    </p>
    <img class="help-modal-image" width="370" height="270" src="../videos/hints/rotate_edge_tangent.gif" />`;
    helpModalAdditionalOptionsHTML = `
    <p>
    <b>NOT ACTIVE YET:</b><br>
      This functionality is not yet activated. <br>
    <b>Tangents at smooth joints:</b><br>
       If two edges join smoothly, manipulating the tangent of the one at the smooth joint will have an equivalent efffect on the tangent of the other one, as their
       tangents must match.
    </p>`;
  }

  else if (modal_type == "smoothen_faces") {
    helpModalTitle= "Make selected pair of faces join smoothly";
    helpModalSummaryText = `Make two faces that share an edge join smoothly.`;
    helpModalDefaultUsageHTML = `<p>
      Select the two faces, then click on this icon.
    </p>
    <div style="padding:56.25% 0 0 0;position:relative;">
    <iframe src="https://player.vimeo.com/video/564024113#t=2m44s?loop=1&title=0&byline=0&portrait=0"
    style="position:absolute;top:0;left:0;width:100%;height:100%;"
    frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen>
    </iframe>
   </div>
   <script src="https://player.vimeo.com/api/player.js"></script>
    `;
    helpModalAdditionalOptionsHTML = `<p>
    <b> Current limitations:</b><br>
      There are currently some limitations to this functionality, which are being gradually removed.
      Please see related tutorial for more information.<br>
    </p>`;

  }

  else if (modal_type == "unsmoothen_faces") {
    helpModalTitle= "Remove smoothness requirement from pair of faces";
    helpModalSummaryText = `Allow two faces that share an edge to join non-smoothly.`;
    helpModalDefaultUsageHTML = `<p>
      Select the two faces, then click on this icon.
    </p>
    <div style="padding:56.25% 0 0 0;position:relative;">
    <iframe src="https://player.vimeo.com/video/564024113?loop=1&title=0&byline=0&portrait=0"
    style="position:absolute;top:0;left:0;width:100%;height:100%;"
    frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen>
    </iframe>
   </div>
   <script src="https://player.vimeo.com/api/player.js"></script>
   `;
    helpModalAdditionalOptionsHTML = `<p><b>   </b><br>

    </p>`;
  }

  else if (modal_type == "refresh") {
    helpModalTitle= "Start a new model";
    helpModalSummaryText = `Discard the current model and start a new one.`;
    helpModalDefaultUsageHTML = `<p>
      Brings up the window for selecting a model source.
    </p>
    <p>
      To start a new model you will be presented with the following options:
      <ul>
      <li> Start from a default primitive shape (cube, cylinder, etc)</li>
      <li> Load a model that has been saved in the .phi format in your Onshape document</li>
      <li> Load a model that has been saved in the .phi format in a local file</li>
      </ul>
    </p>
    `;
  }

  else if (modal_type == "add_model") {
    helpModalTitle= "Add another model";
    helpModalSummaryText = `Add another model into the current one.`;
    helpModalDefaultUsageHTML = `<p>
      Allows you to load another model and add it into the current one you are working on. It
      brings up the window for selecting a model source.
    </p>
    <p>
      To load another model into the current you will be presented with the following options:
      <ul>
      <li> Load a default primitive shape (cube, cylinder, etc)</li>
      <li> Load a model that has been saved in the .phi format in your Onshape document</li>
      <li> Load a model that has been saved in the .phi format in a local file</li>
      </ul>
    </p>
    `;
  }

  else if (modal_type == "mirror") {
    helpModalTitle= "Mirror model";
    helpModalSummaryText = `Create a mirror image of your model`;
    helpModalDefaultUsageHTML = `<p>
    First you click on the icon, then click on one of the three orthogonal planes, and a mirror image of your model will be added with respect
    to the selected plane.
    </p>
    <div style="padding:56.25% 0 0 0;position:relative;">
    <iframe src="https://player.vimeo.com/video/563131452?loop=1&title=0&byline=0&portrait=0"
    style="position:absolute;top:0;left:0;width:100%;height:100%;"
    frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen>
    </iframe>
   </div>
   <script src="https://player.vimeo.com/api/player.js"></script>
   `;
    helpModalAdditionalOptionsHTML = `
    <p>
    <b>Hiding the mirror plane:</b><br>
    If the mirror plane gets in the way of your design work, you can hide it by hiding the orthogonal axes. The mirroring will still be applied,
    but the plane will not be visible.
    </p>`;
  }

  else if (modal_type == "deghostify-mirror") {
    helpModalTitle= "Materialize Mirror Image";
    helpModalSummaryText = `While in mirror mode, select one or more faces of bodies, and turn their mirror images into new, independent bodies.`;
    helpModalDefaultUsageHTML = `<p>
    After a mirror plane has been set, and while the mirror image is shown, select one or more faces of the mirrored object (either the mirror source body, or its mirrored image). Then click on this button. The mirror image will turn into a new body, which can be independently handled, even after you exit the mirror mode.
    </p>
    <div style="padding:56.25% 0 0 0;position:relative;">
    <iframe src="https://player.vimeo.com/video/563131452#t=54?loop=1&title=0&byline=0&portrait=0"
    style="position:absolute;top:0;left:0;width:100%;height:100%;"
    frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen>
    </iframe>
   </div>
   <script src="https://player.vimeo.com/api/player.js"></script>
   `;
    helpModalAdditionalOptionsHTML = `
    <p>
    <b>Active in mirror mode:</b><br>
    This button can be used after a mirror plane has been set, and the mirror image is shown.
    </p>`;
  }

  else if (modal_type == "clone_body") {
    helpModalTitle= "Copy selected bodies or faces";
    helpModalSummaryText = `Create a copy of the currently selected bodies or faces`;
    helpModalDefaultUsageHTML = `<p>
    Select one or more faces or entire bodies, and then click on this icon or hit the Ctrl-C shortcut. A copy of each of the selected faces or bodies will
    be created, and a manipulator will instantly appear for you to move the copies out of the way.
    </p>
    <div style="padding:56.25% 0 0 0;position:relative;">
    <iframe src="https://player.vimeo.com/video/563235110?loop=1&title=0&byline=0&portrait=0"
    style="position:absolute;top:0;left:0;width:100%;height:100%;"
    frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen>
    </iframe>
   </div>
   <script src="https://player.vimeo.com/api/player.js"></script>
   `;
    helpModalAdditionalOptionsHTML = `
    <p>
    <b>Must move the copy:</b><br>
    The copies are originally placed exactly at the location of the originals, so if you don't move them they will be superimposed.
    To prevent this, the manipulator won't go away until you either move the copies, or explicitly hit the Move icon or shortcut.
    </p>`;
    helpModalShortcutsHTML = `<p><ul>
    <li class='shortcuts__item'><b>Ctrl-C</b>: Copy body or face</li>
    </ul></p>`;
  }

  else if (modal_type == "clone_edge") {
    helpModalTitle= "Copy edge";
    helpModalSummaryText = `Create one or more scaled copies of an edge`;
    helpModalDefaultUsageHTML = `<p>
    Select a driving edge and one vertex of it. Then select one or more other edges, plus a vertex on each one of them. Then click on the icon or use
    the Ctrl-C shortcut. Each of the edges will be modified to be a copy of the driving edge, scaled so that no vertices will move.
    </p>
    <div style="padding:56.25% 0 0 0;position:relative;">
    <iframe src="https://player.vimeo.com/video/564377173?loop=1&title=0&byline=0&portrait=0"
    style="position:absolute;top:0;left:0;width:100%;height:100%;"
    frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen>
    </iframe>
   </div>
   <script src="https://player.vimeo.com/api/player.js"></script>
   `;
    helpModalAdditionalOptionsHTML = `
    <p>
    <b>Vertex correspondence:</b><br>
    The reason you must select a vertex for each edge is so that the copy will take place with the vertices in correspondence.<br>
    <b>Copied edge orientation:</b><br>
    In making a copy of the edge, we must decide how to orient it within 3D space. The two endpoints allow for one rotational degree of freedom.
    We currently decide based on the edge shape of each edge before being modified.<br>
    </p>`;
    helpModalShortcutsHTML = `<p><ul>
    <li class='shortcuts__item'><b>Ctrl-C</b>: Copy edge</li>
    </ul></p>`;
  }

  else if (modal_type == "save_model") {
    helpModalTitle= "Save model";
    helpModalSummaryText = `Saves a copy of your model in the Phi format`;
    helpModalDefaultUsageHTML = `<p>
    Type in a filename, and choose whether you want to save the copy within your current Onshape document, or to a file on your local filesystem.
    </p>

    <div style="padding:56.25% 0 0 0;position:relative;">
        <iframe src="https://player.vimeo.com/video/788191074?loop=1&title=0&byline=0&portrait=0"
        style="position:absolute;top:0;left:0;width:100%;height:100%;"
        frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen>
        </iframe>
    </div>
    <script src="https://player.vimeo.com/api/player.js"></script>
    `;

    //<video controls muted autoplay loop width="460">
    //  <source type="video/mp4" src="` + link_pre + `tooltip_animations/set_symmetry_plane.webm` + link_post + `">
    //</video>
    //`;

    helpModalAdditionalOptionsHTML = `
    <p><b>Does Phi autosave?</b><br>
    Yes. While you're working, your design is regularly saved in the background. You can check the status in the bottom left corner.</p>
    <p><b>You save in Onshape as Phi file:</b><br>
    If you choose to save your model within the Onshape document, it will still be saved in the Phi format, it will not be converted to an Onshape Part Studio. There is a separate button for that just below.</p>
  `;
    helpModalShortcutsHTML = `<p><ul>
    <li class='shortcuts__item'><b>Ctrl-S</b>: Save as Phi file</li>
    </ul></p>`;
  }

  else if (modal_type == "send_to_onshape") {
    helpModalTitle= "Send to Onshape";
    helpModalSummaryText = `Sends your model to your Onshape document as a Part Studio`;
    helpModalDefaultUsageHTML = `<p>
    When you click on this icon, the model you are currently working on will be sent over to the currently open Onshape document and converted into a
    Part Studio. It takes a few seconds for the model to be converted, and you can continue working in the meantime.
    </p>`;
    //<video controls muted autoplay loop width="460">
    //  <source type="video/mp4" src="` + link_pre + `tooltip_animations/set_symmetry_plane.webm` + link_post + `">
    //</video>
    //`;
    helpModalAdditionalOptionsHTML = `
    <p>
    <b>Model is not saved in Phi format:</b><br>
    When you click on this button, your current model will NOT be saved in the Phi format, and therefore you cannot load it back to continue working
    on it. Instead it will be translated into an Onshape Part Studio. There is a separate button for saving in the Phi format.<br>
    <b>Existing Part Studio will be live-updated:</b><br>
    When your model conversion into a Part Studio is complete, if a Part Studio of the same name already exists in the document it will be automatically
    updated. If no Part Studio with the same name exists, a new one will be created.
    </p>`;
  }

  else if (modal_type == "import_partstudio_reference_model") {
    helpModalTitle= "Import a reference model from Onshape";
    helpModalSummaryText = `Import a reference model from an Onshape Part Studio.`;
    helpModalDefaultUsageHTML = `<p>
    Click on the icon and select an Onshape Part or Part Studio, which will be loaded as reference. The model will be displayed in blue and, cannot be manipulated as a normal Phi body.
    </p>
    <div style="padding:56.25% 0 0 0;position:relative;">
    <iframe src="https://player.vimeo.com/video/751877642?loop=1&title=0&byline=0&portrait=0"
    style="position:absolute;top:0;left:0;width:100%;height:100%;"
    frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen>
    </iframe>
   </div>
   <script src="https://player.vimeo.com/api/player.js"></script>
    `;
    helpModalAdditionalOptionsHTML = `
    <p>
    <b>"Attempt to convert into editable Phi model"</b><br>
    If switched on, Phi will try to create an editable Phi body which replicates the reference model. Please note that there are certain requirements for a model to be imported successfully. The "Tips" found right below the option will help with that.
    </p>
    <p>
    <b>What can I do with a reference body?</b><br>
    <b>Edit</b>: You can scale and move the imported model. <br>
    <b>Convert</b>: Apart from the option to convert the entire body, individual faces can also be converted.<br>
    <b>Snap/Project</b>: Snap or Project Phi objects onto the imported reference model<br>
    </p>
    <p>
    <b>When is a reference blue or green?</b><br>
    Reference bodies that were imported from Onshape Part studio are blue, while STLs are green. There are different operations you can do with each type.
    </p>
    `;
  }

  else if (modal_type == "import_stl_reference_model") {
    helpModalTitle= "Import an STL reference model from";
    helpModalSummaryText = `Import a reference model in STL format from an Onshape tab.`;
    helpModalDefaultUsageHTML = `<p>
    Click on the icon and select either an Onshape tab containing an STL model. STL models may allow snapping to vertices if the number of vertices in the
    model is not too large.
    </p>
    <div style="padding:56.25% 0 0 0;position:relative;">
    <iframe src="https://player.vimeo.com/video/751882231?loop=1&title=0&byline=0&portrait=0"
    style="position:absolute;top:0;left:0;width:100%;height:100%;"
    frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen>
    </iframe>
   </div>
   <script src="https://player.vimeo.com/api/player.js"></script>
    `;
    helpModalAdditionalOptionsHTML = `
    <p>
    <b>Edit and snap:</b><br>
    You can edit and move the imported model, and snap Phi objects (vertices) onto the imported reference model vertices. If the model
    contains an extremely large number of vertices snapping will be disabled. You can find more details in our tutorial video 13.
    </p>`;
  }


  else if (modal_type == "edit_partstudio_reference_model") {
    helpModalTitle= "Edit reference body";
    helpModalSummaryText = `Move, and scale reference bodies.`;
    helpModalDefaultUsageHTML = `<p>
    Click on the icon to enter edit mode. Then click on any imported reference body to select it. Then use the shortcuts below to modify it.<br>
    When done, click on the icon again to exit the edit mode.</p>
    <div style="padding:56.25% 0 0 0;position:relative;">
    <iframe src="https://player.vimeo.com/video/751877642?loop=1&title=0&byline=0&portrait=0"
    style="position:absolute;top:0;left:0;width:100%;height:100%;"
    frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen>
    </iframe>
   </div>
   <script src="https://player.vimeo.com/api/player.js"></script>
    `;
    helpModalAdditionalOptionsHTML = `
    <p>
    The following editing shortcuts are available:
    <ul class="help-modal-list">
    <li class='shortcuts__item'><b>X, Y, Z</b>: Translate the model along the X, Y or Z direction</li>
    <li class='shortcuts__item'><b>Shift-X, Shift-Y, Shift-Z</b>: Translate the model along the -X, -Y or -Z direction</li>
    <li class='shortcuts__item'><b>Up-arrow, Down-arrow</b>: Scale the model up or down proportionately.</li>
    <li class='shortcuts__item'><b>1, 2 and 3, and Shift-1, Shift-2 and Shift-3</b>: Scale the model up or down along X, Y and Z respectively.</li>
    <li class='shortcuts__item'><b>Delete</b> or <b>Backspace</b>: Delete the reference body.</li>
    </ul>
    </p>`;
    helpModalShortcutsHTML = `<p><ul>
    <li class='shortcuts__item'><b>X, Y, Z</b>: Translate the model along the X, Y or Z direction</li>
    <li class='shortcuts__item'><b>Shift-X, Shift-Y, Shift-Z</b>: Translate the model along the -X, -Y or -Z direction</li>
    <li class='shortcuts__item'><b>Up-arrow, Down-arrow</b>: Scale the model up or down proportionately.</li>
    <li class='shortcuts__item'><b>1, 2 and 3, and Shift-1, Shift-2 and Shift-3</b>: Scale the model up or down along X, Y and Z respectively.</li>
    <li class='shortcuts__item'><b>Delete</b> or <b>Backspace</b>: Delete the reference body.</li>
    </ul></p>`;
  }

  else if (modal_type == "edit_stl_reference_model") {
    helpModalTitle= "Edit reference body";
    helpModalSummaryText = `Move, and scale reference bodies.`;
    helpModalDefaultUsageHTML = `<p>
    Click on the icon to enter edit mode. Then click on any imported reference body to select it. Then use the shortcuts below to modify it.<br>
    When done, click on the icon again to exit the edit mode.</p>
    <div style="padding:56.25% 0 0 0;position:relative;">
    <iframe src="https://player.vimeo.com/video/562752361?loop=1&title=0&byline=0&portrait=0"
    style="position:absolute;top:0;left:0;width:100%;height:100%;"
    frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen>
    </iframe>
   </div>
   <script src="https://player.vimeo.com/api/player.js"></script>
    `;
    helpModalAdditionalOptionsHTML = `
    <p>
    The following editing shortcuts are available:
    <ul class="help-modal-list">
    <li class='shortcuts__item'><b>X, Y, Z</b>: Translate the model along the X, Y or Z direction</li>
    <li class='shortcuts__item'><b>Shift-X, Shift-Y, Shift-Z</b>: Translate the model along the -X, -Y or -Z direction</li>
    <li class='shortcuts__item'><b>Up-arrow, Down-arrow</b>: Scale the model up or down proportionately.</li>
    <li class='shortcuts__item'><b>1, 2 and 3, and Shift-1, Shift-2 and Shift-3</b>: Scale the model up or down along X, Y and Z respectively.</li>
    <li class='shortcuts__item'><b>Delete</b> or <b>Backspace</b>: Delete the reference body.</li>
    </ul>
    </p>`;
    helpModalShortcutsHTML = `<p><ul>
    <li class='shortcuts__item'><b>X, Y, Z</b>: Translate the model along the X, Y or Z direction</li>
    <li class='shortcuts__item'><b>Shift-X, Shift-Y, Shift-Z</b>: Translate the model along the -X, -Y or -Z direction</li>
    <li class='shortcuts__item'><b>Up-arrow, Down-arrow</b>: Scale the model up or down proportionately.</li>
    <li class='shortcuts__item'><b>1, 2 and 3, and Shift-1, Shift-2 and Shift-3</b>: Scale the model up or down along X, Y and Z respectively.</li>
    <li class='shortcuts__item'><b>Delete</b> or <b>Backspace</b>: Delete the reference body.</li>
    </ul></p>`;
  }

  else if (modal_type == "snap_to_object") {
    helpModalTitle= "Snap to object";
    helpModalSummaryText = `Make a vertex, edge or face snap to another vertex, edge or face, either of a phi body or from an imported reference model.`;
    helpModalDefaultUsageHTML = `<p>
    Select the object you want to snap, then click on this icon, then click or shift-click the target you want to snap to. The prompt explains in real-time how Shift will affect result.
    </p>
    <div style="padding:56.25% 0 0 0;position:relative;">
    <iframe src="https://player.vimeo.com/video/564006398?loop=1&title=0&byline=0&portrait=0"
    style="position:absolute;top:0;left:0;width:100%;height:100%;"
    frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen>
    </iframe>
   </div>
   <script src="https://player.vimeo.com/api/player.js"></script>
    `;
    helpModalAdditionalOptionsHTML = `<p>
        <b>Use Shift for different behaviour:</b><br>
        By keeping Shift pressed when you click the target object, you can have a different behaviour:
    </p>

    <ul>
        <li class='shortcuts__item'>
            When snapping an edge to another edge, it will not snap to the entire length of the target edge,
            but to a part of it that corresponds to the initial shape of the moving edge.
        </li>
        <li class='shortcuts__item'>
            When snapping a vertex onto another vertex or edge, the vertex will not move alone, instead the
            entire body will rigidly follow it.
        </li>
    </ul>`;

    helpModalShortcutsHTML = `<p><ul>
        <li class='shortcuts__item'><b>N</b>: Snap to target</li>
    </ul></p>`;
  }


  else if (modal_type == "export_model") {
    helpModalTitle= "Export model to other format";
    helpModalSummaryText = `Export your model to STL or STEP format.`;
    helpModalDefaultUsageHTML = `<p>
    Click on the icon to export your model to STL or STEP file format.  The generated file is saved on your local file system.
    </p>`;
    helpModalAdditionalOptionsHTML = `
    <p>
    <!--
    <b>STEP downloaded from server:</b><br>
    When exporting to STEP, the translation takes place on our server, and you will be presented with a link to download the STEP file.<br>
    -->
    <b>Number of triangles for STL:</b><br>
    When exporting to STL, you will be asked to specify approximately how many triangles per face you want to have in the generated STL file.
    This will affect precision but also file size.
    </p>`;
  }

  else if (modal_type == "toggle_clipping") {
    helpModalTitle= "Set section planes";
    helpModalSummaryText = `Set the section planes, or exit section view.`;
    helpModalDefaultUsageHTML = `<p>
    To set the position of the section plane(s), first you click on the icon to enter the "setting section plane" mode. A box will appear around your model, which you can edit by dragging any of the faces. Where each of these faces intersects with your model, the model area that has been left outside the box will become invisible.
    </p>
    <p>
    When you are done, you can click the same icon again to turn section view off, or hover it and click the “Edit model in section view”.
    </p>
    <div style="padding:56.25% 0 0 0;position:relative;">
    <iframe src="https://player.vimeo.com/video/652537975?loop=1&title=0&byline=0&portrait=0"
    style="position:absolute;top:0;left:0;width:100%;height:100%;"
    frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen>
    </iframe>
       </div>
       <script src="https://player.vimeo.com/api/player.js"></script>
       `;
    helpModalAdditionalOptionsHTML = `
    <p>
    <b>Exiting Section View:</b><br>
    If you click this icon while in section mode (either “Setting section planes” or “Editing model in section view”), you will exit both of them and see your entire model again, unsectioned. This does not clear the section planes.
    </p>
    <p>
    <b>Preservation of the section planes:</b><br>
    By default, once you exit the section mode, the section planes will remain where you have set them, so that you find them intact the next time you enter the mode. However, certain operations (such us “Load model”) will clear the set section planes.
    </p>
    <p>
    <b>Undo:</b><br>
    Moving a section plane cannot be undone with the undo button.
    </p>
    <p>
    <b>Why is my model hollow?:</b><br>
    Phi only shows the surfaces of the model. A closed-surface model should normally be solid when exported.
    </p>`;
  }

  else if (modal_type == "toggle_clipping_edit_model") {
    helpModalTitle= "Edit model at section view";
    helpModalSummaryText = `Edit your model while in section view, or return to the “Setting section planes” mode.`;
    helpModalDefaultUsageHTML = `<p>
    Once the section planes are set, click on this icon to work on your model or reference model, while these are shown in section.
    </p>
    <p>
    You can switch to the “Setting section planes” mode and readjust the section planes anytime, by clicking on this icon again. Otherwise, you can exit Section view entirely by clicking the “Set section planes” button.
    </p>
    <div style="padding:56.25% 0 0 0;position:relative;">
    <iframe src="https://player.vimeo.com/video/652537975#t=39?loop=1&title=0&byline=0&portrait=0"
    style="position:absolute;top:0;left:0;width:100%;height:100%;"
    frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen>
    </iframe>
        </div>
        <script src="https://player.vimeo.com/api/player.js"></script>
        `;
    helpModalAdditionalOptionsHTML = `
    <p>
    <b>Inactive button:</b><br>
    This button will become active once you click "Set Section planes" (the button below this one).
    </p>`;
  }

  else if (modal_type == "save_cropped_stl") {
    helpModalTitle= "Save cropped STL";
    helpModalSummaryText = `Save the reference STL model to file. If in section view, only the visible part will be saved.`;
    helpModalDefaultUsageHTML = `
    <div style="padding:56.25% 0 0 0;position:relative;">
    <iframe src="https://player.vimeo.com/video/665366814?loop=1&title=0&byline=0&portrait=0"
    style="position:absolute;top:0;left:0;width:100%;height:100%;"
    frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen>
    </iframe>
        </div>
        <script src="https://player.vimeo.com/api/player.js"></script>
        `;
    helpModalAdditionalOptionsHTML = `
    <p><b>Why crop my STL?</b><br>
    Apart from making your handling of the STL easier in some cases, a cropped STL can also significantly improve performance, as there is less data for Phi to process.
    </p>
    <p><b>Why is the file size of the output larger than that of the input?</b><br>
    The reason this might happen is that Phi currently saves STLs in text format. Even in those cases, the output will be faster to process, though.
    </p>
    <p><b>Inactive button:</b><br>
    The button will become active after an STL has been loaded.
    </p>`;
  }

  else if (modal_type == "reduce_stl") {
    helpModalTitle= "Save STL with reduced resolution (beta)";
    helpModalSummaryText = `Subsample and save the STL in a new file.`;
    helpModalDefaultUsageHTML = `<p>
    Give a factor that defines the resolution of the output. A smaller factor results in a smaller number triangles.
    </p>
    <p>
    The following video presents some examples of how this factor affects the resolution:
    </p>
    <div style="padding:56.25% 0 0 0;position:relative;">
    <iframe src="https://player.vimeo.com/video/665366814#t=47?loop=1&title=0&byline=0&portrait=0"
    style="position:absolute;top:0;left:0;width:100%;height:100%;"
    frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen>
    </iframe>
        </div>
        <script src="https://player.vimeo.com/api/player.js"></script>
        `;
    helpModalAdditionalOptionsHTML = `
    <p>
    <b>This tool is in beta version:</b><br>
    Feel free to let us know of any comments.
    </p>
    <p><b>Why reduce the resolution of my STL?</b><br>
    A lower number of triangles can significantly improve performance: operations such as attach to STL will complete faster, as there are less triangles for Phi to process.
    </p>
    <p><b>Why is the file size of the output larger than that of the input?</b><br>
    The reason this might happen is that Phi currently saves STLs in text format. Even in those cases, the output will be faster to process, though.
    </p>
    <p><b>Inactive button:</b><br>
    The button will become active after an STL has been loaded.
    </p>`;
  }

  else if (modal_type == "attach_to_stl") {
    helpModalTitle= "Attach to STL";
    helpModalSummaryText = `Attach the selected Phi surfaces onto reference STL files.`
    helpModalDefaultUsageHTML = `
      <p>
          Click this button to enter the relevant mode, then hit keys "1", "2", ("3") in sequence:
          <ul>
            <li>"1" attaches all vertices to the STL surface.</li>
            <li>"2" deforms the edges onto follow the STL surface.</li>
            <li>"3" (optionally) for further smoothening.</li>
          </ul>
          At any time you can select a part of the surface, move it, then repeat for slightly different results. Click this button again to exit the mode.
        </p>

    <div style="padding:56.25% 0 0 0;position:relative;">
    <iframe src="https://player.vimeo.com/video/665314271?loop=1&title=0&byline=0&portrait=0"
    style="position:absolute;top:0;left:0;width:100%;height:100%;"
    frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen>
    </iframe>
        </div>
        <script src="https://player.vimeo.com/api/player.js"></script>
        `;
    helpModalAdditionalOptionsHTML = `
      <p>
          <b>This is the suggested procedure in detail:</b>
    <ol>
      <li>Prepare the STL (optional)
        <i>This will reduce process time later on.</i>
        <ul>
          <li>If the resolution of the STL is higher than needed, you can reduce it with the relevant tool (button lies on the right of this one.)</li>
          <li>If you only need a portion of the STL to work with, you can crop the rest out with the relevant tool (button lies on the left of this one).</li>
        </ul>
                </li>
      <li>Prepare the Phi surface
        <ul>
          <li>The Phi surface(s) need to roughly follow the STL surface.</li>
          <li>Divide the surface into more faces (Add edges, Split, Crosshair etc.)</li>
        </ul>
      </li>
      <li>Run the operation
        <ol>
          <li>Select the faces to be attached.</li>
          <li>Click the "Attach Phi surfaces to STL" button.<br><i>This will put you into the relevant mode, so that Phi gets ready for the next steps. Also, Phi will temporarily crop out STL parts that are unnecessary for this operation (i.e. are too far away to consider). </i></li>
          <li>Hit key "1"<br><i>Each vertex of the selected faces will be moved to its closest STL point.</i></li>
          <li>Hit key "2"<br><i>Each edge of the selected faces will be deformed to follow the STL surface</i></li>
          <li>Optionally, hit key "3"<br><i>This will smoothen selected edges (if any), and perform a consistency check to automatically fix any discontinuities.</i></li>
          <li>The above can be repeated for a particular selection, or after manual adjustments.</li>
          <li>Click the "Attach Phi surfaces to STL" button again.<br><i>This will exit the relevant mode and restore the STL cropped area.</i></li>
        </ol>
      </li>
    </ol>
        </p>

    <p>
    <b>Inactive button:</b><br>
    The button will become active after an STL has been loaded.
    </p><p>
    <b>This tool is in beta version:</b><br>
    Feel free to let us know of any comments.
    </p>`;
    helpModalShortcutsHTML = `<p><ul>
    <li class='shortcuts__item'><b>1</b>: Attach vertices</li>
    <li class='shortcuts__item'><b>2</b>: Attach edges</li>
    <li class='shortcuts__item'><b>3</b>: Smoothen and fix consistency</li>
    </ul></p>`;
  }

  else if (modal_type == "select_coinciding_vert") {
    helpModalTitle= "Selecting Coinciding Vertices";
    helpModalSummaryText = `How to select the vertex you want, among coinciding vertices`;
    helpModalDefaultUsageHTML = `<p>
    If two or more vertices occupy the same position, you can repeatedly click on them as follows:
    <ol>
      <li>Click once (to randomly select one of the coinciding vertices). The selected vertex will be indicated by highlighting the edges that come out of it.</li>
      <li>If that was the vertex you wanted, stop this process and carry on with your selection as usual. If you need to switch your selection:</li>
      <li>Click again twice:
        <ol type="a">
          <li>once to deselect the first vertex,</li>
          <li>and once more to select the next one of the coinciding vertices.</li>
        </ol>
      </li>
      <li>Repeat steps 2-3 until you have selected the vertex you want (the relevant edges will be highlighted each time).</li>
    </ol>
    </p>
    <div style="padding:56.25% 0 0 0;position:relative;">
    <iframe src="https://player.vimeo.com/video/682083267?loop=1&title=0&byline=0&portrait=0"
    style="position:absolute;top:0;left:0;width:100%;height:100%;"
    frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen>
    </iframe>
    </div>
    <script src="https://player.vimeo.com/api/player.js"></script>
    `;
    helpModalAdditionalOptionsHTML = `
    <p>
    <b>Alternative ways of deselecting:</b><br>
    In Step 3a, you can alternatively hit Escape or click anywhere on the black area; however, this will also deselect any other elements you might have already selected.
    </p>`;
  }

  else if (modal_type == "smoothen_objects") {
    helpModalTitle= "Smooth";
    helpModalSummaryText = `Smooth edges, faces, vertices or area`;
    helpModalDefaultUsageHTML = `
    <p>Smoothens selected edges, vertices, faces, or entire area around selected objects.</p>
    <p>If necessary it will also add any tangencies to ensure smoothness.</p>

    <div style="padding:56.25% 0 0 0;position:relative;">
    <iframe src="https://player.vimeo.com/video/564024113?loop=1&title=0&byline=0&portrait=0"
    style="position:absolute;top:0;left:0;width:100%;height:100%;"
    frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen>
    </iframe>

   </div>
   <script src="https://player.vimeo.com/api/player.js"></script>
   `;

    helpModalAdditionalOptionsHTML = `
    <p><b>Additive effect:</b><br>
    Repeatedly clicking on the icon will make the selection progressively smoother.</p>
    <p><b>Temporarily lock all vertices in place with Shift:</b><br>
    If the Shift key is pressed when you click this icon, no vertices will move.</p>
    <p><b>Fixed vertices:</b><br>
    To prevent only some vertices from moving, Fix them before Smoothing.</p>`;

    helpModalShortcutsHTML = `<p><ul>
    <li class='shortcuts__item'><b>U</b>: Smoothen</li>
    <li class='shortcuts__item'><b>Shift-U</b>: Smoothen without moving vertices</li>
    </ul></p>`;
  }


  else if (modal_type == "unsmoothen_objects") {
    helpModalTitle= "Unsmooth";
    helpModalSummaryText = `Unsmooth edges, faces, vertices or area`;
    helpModalDefaultUsageHTML = `
    <p>Unsmoothens selected edges, vertices, faces, or entire area around selected objects.</p>
    <p>The shape will change minimally, and smoothness will no longer be enforced.</p>

    <div style="padding:56.25% 0 0 0;position:relative;">
    <iframe src="https://player.vimeo.com/video/564024113#t=2m29s?loop=1&title=0&byline=0&portrait=0"
    style="position:absolute;top:0;left:0;width:100%;height:100%;"
    frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen>
    </iframe>
   </div>

   <script src="https://player.vimeo.com/api/player.js"></script>
   `;
    helpModalAdditionalOptionsHTML = ` `;
  }


  else if (modal_type == "edge_to_face_tangency") {
    helpModalTitle= "Tangent edge w.r.t. face";
    helpModalSummaryText = `Make an edge tangent with respect to a face.`;
    helpModalDefaultUsageHTML = `
    <p>Select the edge and the face, then click this icon.</p>

    <div style="padding:56.25% 0 0 0;position:relative;">
    <iframe src="https://player.vimeo.com/video/694047218#t=0m8s?loop=1&title=0&byline=0&portrait=0"
    style="position:absolute;top:0;left:0;width:100%;height:100%;"
    frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen>
    </iframe>
   </div>

   <script src="https://player.vimeo.com/api/player.js"></script>
   `;
    helpModalAdditionalOptionsHTML = `<p><b>Tangency does not follow if face is changed:</b><br>
    If the face is significantly changed after tangency has been applied, tangency might disconnect and need to be applied again.</p>`;
  }



  else if (modal_type == "edge_to_plane_perpendicular") {
    helpModalTitle= "Perpendicular edge w.r.t. plane";
    helpModalSummaryText = `Make an edge perpendicular to a face, or plane.`;
    helpModalDefaultUsageHTML = `
    <p>Select the edge (and vertex if necessary), then click on this icon, then define the face or plane.</p>

    <div style="padding:56.25% 0 0 0;position:relative;">
    <iframe src="https://player.vimeo.com/video/694047218#t=0m39s?loop=1&title=0&byline=0&portrait=0"
    style="position:absolute;top:0;left:0;width:100%;height:100%;"
    frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen>
    </iframe>
   </div>

   <script src="https://player.vimeo.com/api/player.js"></script>
   `;
    helpModalAdditionalOptionsHTML = `
    <p><b>Which side is made perpendicular?</b><br>
    The side that is closest to the plane is made perpendicular, unless a vertex on the edge is selected in which case the side of the vertex is made perpendicular.</p>
    <p><b>How to define a plane:</b><br>
    You can click on a coordinate plane, or a mirror/symmetry plane, or any three vertices.</p>`;
  }


  else if (modal_type == "edge_to_edge_tangent_parallel") {
    helpModalTitle= "Parallel edge tangent w.r.t. another edge";
    helpModalSummaryText = `Make an edge's tangent parallel to the tangent of another edge.`;
    helpModalDefaultUsageHTML = `
    <p>Select at least two edges. The tangent on all edges will be made parallel to the tangent of the first selected edge, on the side where the edge was clicked.</p>

    <div style="padding:56.25% 0 0 0;position:relative;">
    <iframe src="https://player.vimeo.com/video/694047218#t=1m16s?loop=1&title=0&byline=0&portrait=0"
    style="position:absolute;top:0;left:0;width:100%;height:100%;"
    frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen>
    </iframe>
   </div>

   <script src="https://player.vimeo.com/api/player.js"></script>
   `;
    helpModalAdditionalOptionsHTML = ``;
  }


  else if (modal_type == "display_tangencies") {
    helpModalTitle= "Display all tangencies";
    helpModalSummaryText = `Display all fixed edge tangencies or tangencies between edges`;
    helpModalDefaultUsageHTML = `
    <p>Click to display tangencies. Click again to hide.</p>

    <div style="padding:56.25% 0 0 0;position:relative;">
    <iframe src="https://player.vimeo.com/video/694047218#t=1m58s?loop=1&title=0&byline=0&portrait=0"
    style="position:absolute;top:0;left:0;width:100%;height:100%;"
    frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen>
    </iframe>
   </div>

   <script src="https://player.vimeo.com/api/player.js"></script>
   `;
    helpModalAdditionalOptionsHTML = `
    <p><b>Red symbols:</b><br>
    Points where there is fixed tangency.</p>
    <p><b>Purple symbols:</b><br>
    Tangency between edges.</p>
    `;
  }

  else if (modal_type == "project_edges") {
    helpModalTitle= "Project edges onto faces";
    helpModalSummaryText = `Project the selected edges, or the edges of any selected faces, onto any other faces.`
    helpModalDefaultUsageHTML = `<p>In the modal that appears, choose the following:
    <ol>
    <li>The direction of projection:
    	<ul>
    	<li>Onto one or more faces</li>
    	<li>Normal to one of the three orthogonal planes (XY, YZ, XZ)</li>
    	<li>Along a linear edge</li>
    	<li>Along a selected view direction</li>
    	</ul>
    </li>
    <li>Optionally, an offset distance. The value you enter will be added to the projection, so that the edges end up slightly
    inside the object (or stop before the face, if the value is negative).</li>
    </ol>
    </p>

    <p>
    After you press proceed and select the required elements you have to click on the Project button again to start the actual operation!
    </p>

    <div style="padding:56.25% 0 0 0;position:relative;">
    <iframe src="https://player.vimeo.com/video/726041041?loop=1&title=0&byline=0&portrait=0"
    style="position:absolute;top:0;left:0;width:100%;height:100%;"
    frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen>
    </iframe>
   </div>
   <script src="https://player.vimeo.com/api/player.js"></script>
   `;
    helpModalAdditionalOptionsHTML = `
    <p><b> Not a constraint:</b><br>
    This is currently a one-off operation, not a constraint.</p>

    <p><b> Edges are projected and faces follow:</b><br>
    Please note that it's the selected edges that are projected onto the target surface. Selected faces will simply follow their
    surrounding edges being projected. So, in case a face does not follow the target surface, it might need to be divided with additional edges.</p>

    <p><b> Edges are smoothened after the projection:</b><br>
    After the projection takes place, a slight smoothening of the involved edges that were tangent originally is performed, to make sure that
    they will remain tangent after the projection too, unless the geometry has changed too drastically.
    </p>

    `;
  }

  else if (modal_type == "flip_normal") {
    helpModalTitle= "Flip faces";
    helpModalSummaryText = `Flip the normal direction of the faces of all selected surfaces.`
    helpModalDefaultUsageHTML = `<p>Select at least one face of a surface, then click on the icon. The surface will flip: the "inner" side will become the "outer" side, and vice versa.</p>

    <div style="padding:56.25% 0 0 0;position:relative;">
    <iframe src="https://player.vimeo.com/video/732433310?loop=1&title=0&byline=0&portrait=0"
    style="position:absolute;top:0;left:0;width:100%;height:100%;"
    frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen>
    </iframe>
   </div>

   <script src="https://player.vimeo.com/api/player.js"></script>
   `;
    helpModalAdditionalOptionsHTML = `
    <p><b>What is the "inner" side anyway?</b><br>
    By default, the inner side is the red one (unless the relevant Setting has been disabled). In closed bodies the inner side is actually facing inwards, while in surfaces both the inner and outer sides are exposed.</p>

    <p><b> I need to flip a part of my closed body.</b><br>
    Since Flipping is inactive for closed bodies, you need to turn yours into a surface. One way is to select the faces you are intersted in, and Copy them to create a new, separate surface which can be flipped.</p>`;
  }

  else if (modal_type == "convert_ref_to_phi") {
    helpModalTitle= "Convert to Phi objects";
    helpModalSummaryText = `Convert a reference face into a new, editable Phi surface.`
    helpModalDefaultUsageHTML = `<p>Click on this icon, then on the face(s) you want to convert, then again on this icon. A new Phi face will be created following the reference face.</p>
    <p>In case you hold the Shift key down when you click this icon, a new 0-thickness body will be created, consisting of two opposite faces. (You can make either one invisible)</p>

    <div style="padding:56.25% 0 0 0;position:relative;">
    <iframe src="https://player.vimeo.com/video/734781041?loop=1&title=0&byline=0&portrait=0"
    style="position:absolute;top:0;left:0;width:100%;height:100%;"
    frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen>
    </iframe>
   </div>

   <script src="https://player.vimeo.com/api/player.js"></script>
   `;
    helpModalAdditionalOptionsHTML = `
    <p>
    <b>Converting an entire model:</b><br>
    While this button converts faces individually, Phi can optionally attempt to convert an entire model, when that is being imported as reference.
    </p>
    `;
  }

  else if (modal_type === 'display_triangles') {
    helpModalTitle = "Display triangles";
    helpModalSummaryText = "Set the (approximate) number of triangles per face to be used to display the face."
    helpModalDefaultUsageHTML = "Allowed number of triangles is in the range 200 to 20000, with default value of 1600."
    helpModalAdditionalOptionsHTML = `<p><strong>Does not affect surface quality</strong></p>
      <p>This is a visual setting, which only affects how the faces will be displayed. It will not affect the quality of the surfaces. A higher value means that the model looks smoother on your screen and with more detail, but it might also degrade performance.</p>
      <p><strong>Saved in .phi files</strong></p>
      <p>Loading a .phi file will restore this setting to the value it was when the .phi file was saved.</p>`
  }

  else if (modal_type == "manage_tangents_mode") {
    helpModalTitle= "Manage tangents";
    helpModalSummaryText = `Display and work with tangency vectors, using the buttons of the menu below.`;
    helpModalDefaultUsageHTML = `
    <p>Click to enter or exit the "Managing Tangents" mode. While in this mode, you will see tangencies visualised, and work with them using the tools available in the menu below this button.</p>

    <div style="padding:56.25% 0 0 0;position:relative;">
        <iframe src="https://player.vimeo.com/video/785173142?loop=1&title=0&byline=0&portrait=0"
        style="position:absolute;top:0;left:0;width:100%;height:100%;"
        frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen>
        </iframe>
    </div>
   `;

    helpModalAdditionalOptionsHTML = `<p><b>Display only tangents of interest:</b>

    <br>

    Tangency vectors will be displayed only for edges that were selected when you entered the mode, plus any additional edges you select while within this mode. If no edge is selected, then all tangencies will be displayed. Feel free to exit and enter again in order to change displayed tangencies.</p>

    <p>
        <b>What the colors signify:</b>
        <ul>
            <li>
                <b>Green symbols:</b> Free tangents.
                <br>
                Any tangent that has not been locked or edited, and will simply follow the edge.
            </li>
            <li>
                <b>Red symbols:</b> Locked tangents.
                <br>
                These are only editable with the tools within this menu.
            </li>
            <li>
                <b>Purple symbols:</b> Tangency between edges.
                <br>
                In pairs. Behave as Locked tangents, but together.
            </li>
        </ul>
    </p>`;

    helpModalShortcutsHTML = `<p><ul>
    <li class='shortcuts__item'><b>T</b>: Manage Tangents</li>
    </ul></p>`;
  }

  else if (modal_type == "lock_tangent") {
    helpModalTitle= "Lock tangent";
    helpModalSummaryText = `While in "Tangent" mode, select an edge, clicking closer to the end of interest. Then click this button to lock (or unlock) the tangent of that end.`;
    helpModalDefaultUsageHTML = `
    <p>To lock or unlock a tangent of an edge, indicate it by clciking that edge. Differentiate between the two ends, by simply clicking closer to the end you are interested in.</p><p>Then, click this button to lock or unlock that tangent.</p>

    <div style="padding:56.25% 0 0 0;position:relative;">
        <iframe src="https://player.vimeo.com/video/785173142?loop=1&title=0&byline=0&portrait=0"
        style="position:absolute;top:0;left:0;width:100%;height:100%;"
        frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen>
        </iframe>
    </div>
   `;
    helpModalAdditionalOptionsHTML = ` `;

    helpModalShortcutsHTML = `<p><ul>
    <li class='shortcuts__item'><b>X</b>: Lock Tangent</li>
    <li class='shortcuts__item'><b>Shift-X</b>: Unlock Tangent</li>
    </ul></p>`;
  }

  else if (modal_type == "edit_tangent") {
    helpModalTitle= "Edit tangent";
    helpModalSummaryText = `<p>Rotate the tangent at either endpoint of an edge.</p>`;
    helpModalDefaultUsageHTML = `
    <p>To rotate the tangent of an edge, indicate it by clciking that edge. Differentiate between the two ends, by simply clicking closer to the end you are interested in.</p><p>Then, click this button to bring in the move manipulator and use the "Rotate" arrows to rotate that tangent.</p>

    <div style="padding:56.25% 0 0 0;position:relative;">
        <iframe src="https://player.vimeo.com/video/785173142?loop=1&title=0&byline=0&portrait=0"
        style="position:absolute;top:0;left:0;width:100%;height:100%;"
        frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen>
        </iframe>
    </div>
   `;
    helpModalAdditionalOptionsHTML = ` `;

    helpModalShortcutsHTML = `<p><ul>
    <li class='shortcuts__item'><b>M</b>: Edit Tangent</li>
    </ul></p>`;
  }

  // =====================================================================================================
  // Non-button-related help entries =====================================================================
  // =====================================================================================================

  /*
  <li><button class='btn btn--clear' onclick='display_help_modal("highlighting_and_selecting")'>Highlighting and selecting</button></li>
	<li><button class='btn btn--clear' onclick='display_help_modal("directly_editing_objects")'>Directly editing objects</button></li>
	<li><button class='btn btn--clear' onclick='display_help_modal("rotate_pan_zoom")'>Rotate, pan, and zoom</button></li>
	<li><button class='btn btn--clear' onclick='display_help_modal("showing_and_hiding")'>Showing and hiding objects</button></li>
	<li><button class='btn btn--clear' onclick='display_help_modal("tooltips_help_floating")'>Tooltips, help, floating menu</button></li>
	<li><button class='btn btn--clear' onclick='display_help_modal("undo_redo")'>Undo and redo</button></li>




[Directly editing objects]
Key interactions include:

Click and drag any edge to deform it
Click and drag any vertex to move it
Click and drag any face to inflate or deflate it (this is currently only partially available)

If you have the shift key pressed during the above, the movement will be perpendicular to the face of the object. A red or green axis will appear to indicate the movement direction.

As you’ll see below, we make extensive use of the shift key to give alternative versions of many interactions.

On touch interfaces, instead of shift you can press and hold for half a second, and then move your finger or stylus. You’ll get a yellow flash around the interface when the long press has registered.



[Rotate, pan, zoom and viewpoints]
You can rotate your viewpoint with the right mouse button press and move, or with a single finger move on touch devices.

You can also rotate the viewpoint step-wise left and right and up and down with the arrow keys, (15 degrees at a time).

The center of rotation depends on where you press the mouse. If it’s over an object, the center is placed at the mouse location. If it’s over empty space, the center is placed at the “center of mass” of the visible objects.

Also if you right click anywhere on the screen you will set the center of rotation.

You can pan your viewpoint with a middle mouse button press and move, or with a two finger move on touch devices.

And you can zoom in and out with the mouse wheel, or with a two-finger pinch movement on touch devices.

There are 3 buttons at the bottom of the screen to rotate your viewpoint down the x, y, or z axis.

And one more to zoom to view the entire model (the shortcut for this is F for “full” or shift-F for also rotating to an oblique view).



[Showing and hiding]
At the bottom of the screen you have buttons for showing/hiding vertices, edges and faces. Note that if you select some elements and hit the button, only the selected ones will be hidden, whereas if you shift-click the un-selected ones will be hidden. Corresponding shortcuts are Q for vertices, W for edges and R for faces.



[Tooltips, help and floating toolbar]
When you hover your mouse over any tool, a tooltip will appear with a brief description, and clicking on “Read more” will bring up a complete help page for it, including a video describing it.

There is a search box at the top right

Hitting space will bring up a floating toolbar including the currently available commands.


[Undo, redo and start over]
You can undo/redo using the buttons at the top-right of the screen or the shortcuts ctrl-Z, ctrl-Y, or start over with a new model clicking on the refresh button.




  */

  else if (modal_type == "highlighting_and_selecting") {
    helpModalTitle= "Highlighting and Selecting";
    helpModalSummaryText = `<p>Different ways to highlight and select objects.</p>`;
    helpModalDefaultUsageHTML = `<p>

    <b> Hovering over objects</b><br>

    <p>As you hover your mouse over the elements of your design (vertices, edges and faces) they are highlighted, and a circle will slide over them following the mouse to give a better feeling for their orientation.</p>

    <b> Selecting objects</b><br>

    <p>If you click on them they are selected. Click again to deselect, or click on empty space or hit escape to deselect them.</p>

    Hitting “A” (all) will select all of the visible objects.</p>

    <p>Shift-clicking on a face will select the entire body.</p>

    <p>And shift-clicking on an edge will select an entire chain or loop of edges.</p>

    <b> Box selection</b><br>
    <p>Click on empty space and drag the mouse to box-select multiple objects.</p>

    <b> Brush selection</b><br>
    <p>Move your mouse with the B key pressed for a “brush selection”, anything the mouse hovers over is selected.</p>
    `;

    helpModalAdditionalOptionsHTML = ` `;

    helpModalShortcutsHTML = ``;
  }


  else {
    //XXX
  }

  document.querySelector('#generic_help_modal header').innerHTML = helpModalTitle;
  document.getElementById('helpModalSummaryText').innerHTML = helpModalSummaryText;
  document.getElementById('helpModalDefaultUsageHTML').innerHTML = helpModalDefaultUsageHTML;
  document.getElementById('helpModalAdditionalOptionsHTML').innerHTML = helpModalAdditionalOptionsHTML;
  document.getElementById('helpModalShortcutsHTML').innerHTML = helpModalShortcutsHTML;
  show_modal('generic_help_modal');
}
